import { jsx as f, jsxs as Q, Fragment as ct } from "react/jsx-runtime";
import * as c from "react";
import De, { useState as Ki, forwardRef as _o, createElement as gn, useLayoutEffect as ji } from "react";
import * as Bt from "react-dom";
import Yi from "react-dom";
function Oo(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = Oo(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function Do() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = Oo(e)) && (o && (o += " "), o += t);
  return o;
}
const An = "-", Xi = (e) => {
  const t = Zi(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: o
  } = e;
  return {
    getClassGroupId: (a) => {
      const i = a.split(An);
      return i[0] === "" && i.length !== 1 && i.shift(), ko(i, t) || qi(a);
    },
    getConflictingClassGroupIds: (a, i) => {
      const l = n[a] || [];
      return i && o[a] ? [...l, ...o[a]] : l;
    }
  };
}, ko = (e, t) => {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], o = t.nextPart.get(n), r = o ? ko(e.slice(1), o) : void 0;
  if (r)
    return r;
  if (t.validators.length === 0)
    return;
  const s = e.join(An);
  return (a = t.validators.find(({
    validator: i
  }) => i(s))) == null ? void 0 : a.classGroupId;
}, to = /^\[(.+)\]$/, qi = (e) => {
  if (to.test(e)) {
    const t = to.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Zi = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Ji(Object.entries(e.classGroups), n).forEach(([s, a]) => {
    hn(a, o, s, t);
  }), o;
}, hn = (e, t, n, o) => {
  e.forEach((r) => {
    if (typeof r == "string") {
      const s = r === "" ? t : no(t, r);
      s.classGroupId = n;
      return;
    }
    if (typeof r == "function") {
      if (Qi(r)) {
        hn(r(o), t, n, o);
        return;
      }
      t.validators.push({
        validator: r,
        classGroupId: n
      });
      return;
    }
    Object.entries(r).forEach(([s, a]) => {
      hn(a, no(t, s), n, o);
    });
  });
}, no = (e, t) => {
  let n = e;
  return t.split(An).forEach((o) => {
    n.nextPart.has(o) || n.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(o);
  }), n;
}, Qi = (e) => e.isThemeGetter, Ji = (e, t) => t ? e.map(([n, o]) => {
  const r = o.map((s) => typeof s == "string" ? t + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([a, i]) => [t + a, i])) : s);
  return [n, r];
}) : e, ea = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  const r = (s, a) => {
    n.set(s, a), t++, t > e && (t = 0, o = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(s) {
      let a = n.get(s);
      if (a !== void 0)
        return a;
      if ((a = o.get(s)) !== void 0)
        return r(s, a), a;
    },
    set(s, a) {
      n.has(s) ? n.set(s, a) : r(s, a);
    }
  };
}, Lo = "!", ta = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, o = t.length === 1, r = t[0], s = t.length, a = (i) => {
    const l = [];
    let u = 0, d = 0, p;
    for (let h = 0; h < i.length; h++) {
      let w = i[h];
      if (u === 0) {
        if (w === r && (o || i.slice(h, h + s) === t)) {
          l.push(i.slice(d, h)), d = h + s;
          continue;
        }
        if (w === "/") {
          p = h;
          continue;
        }
      }
      w === "[" ? u++ : w === "]" && u--;
    }
    const g = l.length === 0 ? i : i.substring(d), v = g.startsWith(Lo), b = v ? g.substring(1) : g, m = p && p > d ? p - d : void 0;
    return {
      modifiers: l,
      hasImportantModifier: v,
      baseClassName: b,
      maybePostfixModifierPosition: m
    };
  };
  return n ? (i) => n({
    className: i,
    parseClassName: a
  }) : a;
}, na = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((o) => {
    o[0] === "[" ? (t.push(...n.sort(), o), n = []) : n.push(o);
  }), t.push(...n.sort()), t;
}, oa = (e) => ({
  cache: ea(e.cacheSize),
  parseClassName: ta(e),
  ...Xi(e)
}), ra = /\s+/, sa = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: o,
    getConflictingClassGroupIds: r
  } = t, s = [], a = e.trim().split(ra);
  let i = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const u = a[l], {
      modifiers: d,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: v
    } = n(u);
    let b = !!v, m = o(b ? g.substring(0, v) : g);
    if (!m) {
      if (!b) {
        i = u + (i.length > 0 ? " " + i : i);
        continue;
      }
      if (m = o(g), !m) {
        i = u + (i.length > 0 ? " " + i : i);
        continue;
      }
      b = !1;
    }
    const h = na(d).join(":"), w = p ? h + Lo : h, y = w + m;
    if (s.includes(y))
      continue;
    s.push(y);
    const x = r(m, b);
    for (let C = 0; C < x.length; ++C) {
      const S = x[C];
      s.push(w + S);
    }
    i = u + (i.length > 0 ? " " + i : i);
  }
  return i;
};
function ia() {
  let e = 0, t, n, o = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Fo(t)) && (o && (o += " "), o += n);
  return o;
}
const Fo = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (t = Fo(e[o])) && (n && (n += " "), n += t);
  return n;
};
function aa(e, ...t) {
  let n, o, r, s = a;
  function a(l) {
    const u = t.reduce((d, p) => p(d), e());
    return n = oa(u), o = n.cache.get, r = n.cache.set, s = i, i(l);
  }
  function i(l) {
    const u = o(l);
    if (u)
      return u;
    const d = sa(l, n);
    return r(l, d), d;
  }
  return function() {
    return s(ia.apply(null, arguments));
  };
}
const Z = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, $o = /^\[(?:([a-z-]+):)?(.+)\]$/i, ca = /^\d+\/\d+$/, la = /* @__PURE__ */ new Set(["px", "full", "screen"]), ua = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, da = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, fa = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, pa = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, ma = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Ce = (e) => He(e) || la.has(e) || ca.test(e), Ee = (e) => qe(e, "length", Ca), He = (e) => !!e && !Number.isNaN(Number(e)), on = (e) => qe(e, "number", He), rt = (e) => !!e && Number.isInteger(Number(e)), ga = (e) => e.endsWith("%") && He(e.slice(0, -1)), F = (e) => $o.test(e), Ne = (e) => ua.test(e), ha = /* @__PURE__ */ new Set(["length", "size", "percentage"]), va = (e) => qe(e, ha, Bo), ba = (e) => qe(e, "position", Bo), wa = /* @__PURE__ */ new Set(["image", "url"]), ya = (e) => qe(e, wa, Ra), xa = (e) => qe(e, "", Sa), st = () => !0, qe = (e, t, n) => {
  const o = $o.exec(e);
  return o ? o[1] ? typeof t == "string" ? o[1] === t : t.has(o[1]) : n(o[2]) : !1;
}, Ca = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  da.test(e) && !fa.test(e)
), Bo = () => !1, Sa = (e) => pa.test(e), Ra = (e) => ma.test(e), Ea = () => {
  const e = Z("colors"), t = Z("spacing"), n = Z("blur"), o = Z("brightness"), r = Z("borderColor"), s = Z("borderRadius"), a = Z("borderSpacing"), i = Z("borderWidth"), l = Z("contrast"), u = Z("grayscale"), d = Z("hueRotate"), p = Z("invert"), g = Z("gap"), v = Z("gradientColorStops"), b = Z("gradientColorStopPositions"), m = Z("inset"), h = Z("margin"), w = Z("opacity"), y = Z("padding"), x = Z("saturate"), C = Z("scale"), S = Z("sepia"), N = Z("skew"), R = Z("space"), A = Z("translate"), k = () => ["auto", "contain", "none"], D = () => ["auto", "hidden", "clip", "visible", "scroll"], $ = () => ["auto", F, t], M = () => [F, t], B = () => ["", Ce, Ee], L = () => ["auto", He, F], z = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], O = () => ["solid", "dashed", "dotted", "double", "none"], W = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], T = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], E = () => ["", "0", F], G = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], H = () => [He, F];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [st],
      spacing: [Ce, Ee],
      blur: ["none", "", Ne, F],
      brightness: H(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ne, F],
      borderSpacing: M(),
      borderWidth: B(),
      contrast: H(),
      grayscale: E(),
      hueRotate: H(),
      invert: E(),
      gap: M(),
      gradientColorStops: [e],
      gradientColorStopPositions: [ga, Ee],
      inset: $(),
      margin: $(),
      opacity: H(),
      padding: M(),
      saturate: H(),
      scale: H(),
      sepia: E(),
      skew: H(),
      space: M(),
      translate: M()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", F]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ne]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": G()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": G()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...z(), F]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: k()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": k()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": k()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", rt, F]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: $()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", F]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: E()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: E()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", rt, F]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [st]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", rt, F]
        }, F]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": L()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": L()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [st]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [rt, F]
        }, F]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": L()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": L()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", F]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", F]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [g]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [g]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [g]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...T()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...T(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...T(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [h]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [h]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [h]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [h]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [h]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [h]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [h]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [h]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [h]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [R]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [R]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", F, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [F, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [F, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Ne]
        }, Ne]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [F, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [F, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [F, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [F, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ne, Ee]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", on]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [st]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", F]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", He, on]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Ce, F]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", F]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", F]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...O(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Ce, Ee]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Ce, F]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: M()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", F]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", F]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...z(), ba]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", va]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, ya]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [b]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [v]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...O(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: O()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [r]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [r]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [r]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [r]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [r]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [r]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [r]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [r]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [r]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [r]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...O()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ce, F]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Ce, Ee]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: B()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Ce, Ee]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ne, xa]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [st]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...W(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": W()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ne, F]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [p]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [p]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", F]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: H()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", F]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: H()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", F]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [rt, F]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [A]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [A]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [N]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [N]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", F]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", F]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": M()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": M()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": M()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": M()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": M()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": M()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": M()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": M()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": M()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": M()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": M()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": M()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": M()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": M()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": M()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": M()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": M()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": M()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", F]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Ce, Ee, on]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Na = /* @__PURE__ */ aa(Ea);
function I(...e) {
  return Na(Do(e));
}
const oo = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, ro = Do, Wt = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null) return ro(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: s } = t, a = Object.keys(r).map((u) => {
    const d = n == null ? void 0 : n[u], p = s == null ? void 0 : s[u];
    if (d === null) return null;
    const g = oo(d) || oo(p);
    return r[u][g];
  }), i = n && Object.entries(n).reduce((u, d) => {
    let [p, g] = d;
    return g === void 0 || (u[p] = g), u;
  }, {}), l = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((u, d) => {
    let { class: p, className: g, ...v } = d;
    return Object.entries(v).every((b) => {
      let [m, h] = b;
      return Array.isArray(h) ? h.includes({
        ...s,
        ...i
      }[m]) : {
        ...s,
        ...i
      }[m] === h;
    }) ? [
      ...u,
      p,
      g
    ] : u;
  }, []);
  return ro(e, a, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Ma = Wt(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
        success: "border-success/50 text-success dark:border-success [&>svg]:text-success",
        warning: "border-warning/50 text-warning dark:border-warning [&>svg]:text-warning"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Pa = c.forwardRef(({ className: e, variant: t, ...n }, o) => /* @__PURE__ */ f(
  "div",
  {
    ref: o,
    role: "alert",
    className: I(Ma({ variant: t }), e),
    ...n
  }
));
Pa.displayName = "Alert";
const Aa = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "h5",
  {
    ref: n,
    className: I("mb-1 font-medium leading-none tracking-tight", e),
    ...t
  }
));
Aa.displayName = "AlertTitle";
const Ta = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: I("text-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
Ta.displayName = "AlertDescription";
const Ia = Wt(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success: "border-transparent bg-success text-success-foreground hover:bg-success/80",
        warning: "border-transparent bg-warning text-warning-foreground hover:bg-warning/80"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function _a({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ f("div", { className: I(Ia({ variant: t }), e), ...n });
}
function so(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function pt(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const s = so(r, t);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const s = o[r];
          typeof s == "function" ? s() : so(e[r], null);
        }
      };
  };
}
function X(...e) {
  return c.useCallback(pt(...e), e);
}
var Oa = Symbol.for("react.lazy"), At = c[" use ".trim().toString()];
function Da(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function Wo(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === Oa && "_payload" in e && Da(e._payload);
}
// @__NO_SIDE_EFFECTS__
function Vo(e) {
  const t = /* @__PURE__ */ La(e), n = c.forwardRef((o, r) => {
    let { children: s, ...a } = o;
    Wo(s) && typeof At == "function" && (s = At(s._payload));
    const i = c.Children.toArray(s), l = i.find($a);
    if (l) {
      const u = l.props.children, d = i.map((p) => p === l ? c.Children.count(u) > 1 ? c.Children.only(null) : c.isValidElement(u) ? u.props.children : null : p);
      return /* @__PURE__ */ f(t, { ...a, ref: r, children: c.isValidElement(u) ? c.cloneElement(u, void 0, d) : null });
    }
    return /* @__PURE__ */ f(t, { ...a, ref: r, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
var ka = /* @__PURE__ */ Vo("Slot");
// @__NO_SIDE_EFFECTS__
function La(e) {
  const t = c.forwardRef((n, o) => {
    let { children: r, ...s } = n;
    if (Wo(r) && typeof At == "function" && (r = At(r._payload)), c.isValidElement(r)) {
      const a = Wa(r), i = Ba(s, r.props);
      return r.type !== c.Fragment && (i.ref = o ? pt(o, a) : a), c.cloneElement(r, i);
    }
    return c.Children.count(r) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Fa = Symbol("radix.slottable");
function $a(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Fa;
}
function Ba(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], s = t[o];
    /^on[A-Z]/.test(o) ? r && s ? n[o] = (...i) => {
      const l = s(...i);
      return r(...i), l;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...s } : o === "className" && (n[o] = [r, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Wa(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
const Va = Wt(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), zo = c.forwardRef(
  ({ className: e, variant: t, size: n, asChild: o = !1, ...r }, s) => /* @__PURE__ */ f(
    o ? ka : "button",
    {
      className: I(Va({ variant: t, size: n, className: e })),
      ref: s,
      ...r
    }
  )
);
zo.displayName = "Button";
const Go = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: I(
      "rounded-lg border bg-card text-card-foreground shadow-sm",
      e
    ),
    ...t
  }
));
Go.displayName = "Card";
const Ho = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: I("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
Ho.displayName = "CardHeader";
const Uo = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: I(
      "text-2xl font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
Uo.displayName = "CardTitle";
const za = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: I("text-sm text-muted-foreground", e),
    ...t
  }
));
za.displayName = "CardDescription";
const Ko = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f("div", { ref: n, className: I("p-6 pt-0", e), ...t }));
Ko.displayName = "CardContent";
const Ga = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: I("flex items-center p-6 pt-0", e),
    ...t
  }
));
Ga.displayName = "CardFooter";
function P(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function Ha(e, t) {
  const n = c.createContext(t), o = (s) => {
    const { children: a, ...i } = s, l = c.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ f(n.Provider, { value: l, children: a });
  };
  o.displayName = e + "Provider";
  function r(s) {
    const a = c.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return [o, r];
}
function Be(e, t = []) {
  let n = [];
  function o(s, a) {
    const i = c.createContext(a), l = n.length;
    n = [...n, a];
    const u = (p) => {
      var w;
      const { scope: g, children: v, ...b } = p, m = ((w = g == null ? void 0 : g[e]) == null ? void 0 : w[l]) || i, h = c.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ f(m.Provider, { value: h, children: v });
    };
    u.displayName = s + "Provider";
    function d(p, g) {
      var m;
      const v = ((m = g == null ? void 0 : g[e]) == null ? void 0 : m[l]) || i, b = c.useContext(v);
      if (b) return b;
      if (a !== void 0) return a;
      throw new Error(`\`${p}\` must be used within \`${s}\``);
    }
    return [u, d];
  }
  const r = () => {
    const s = n.map((a) => c.createContext(a));
    return function(i) {
      const l = (i == null ? void 0 : i[e]) || s;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: l } }),
        [i, l]
      );
    };
  };
  return r.scopeName = e, [o, Ua(r, ...t)];
}
function Ua(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(s) {
      const a = o.reduce((i, { useScope: l, scopeName: u }) => {
        const p = l(s)[`__scope${u}`];
        return { ...i, ...p };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var J = globalThis != null && globalThis.document ? c.useLayoutEffect : () => {
}, Ka = c[" useId ".trim().toString()] || (() => {
}), ja = 0;
function le(e) {
  const [t, n] = c.useState(Ka());
  return J(() => {
    n((o) => o ?? String(ja++));
  }, [e]), t ? `radix-${t}` : "";
}
var Ya = c[" useInsertionEffect ".trim().toString()] || J;
function je({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: o
}) {
  const [r, s, a] = Xa({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, l = i ? e : r;
  {
    const d = c.useRef(e !== void 0);
    c.useEffect(() => {
      const p = d.current;
      p !== i && console.warn(
        `${o} is changing from ${p ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = i;
    }, [i, o]);
  }
  const u = c.useCallback(
    (d) => {
      var p;
      if (i) {
        const g = qa(d) ? d(e) : d;
        g !== e && ((p = a.current) == null || p.call(a, g));
      } else
        s(d);
    },
    [i, e, s, a]
  );
  return [l, u];
}
function Xa({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = c.useState(e), r = c.useRef(n), s = c.useRef(t);
  return Ya(() => {
    s.current = t;
  }, [t]), c.useEffect(() => {
    var a;
    r.current !== n && ((a = s.current) == null || a.call(s, n), r.current = n);
  }, [n, r]), [n, o, s];
}
function qa(e) {
  return typeof e == "function";
}
// @__NO_SIDE_EFFECTS__
function Ye(e) {
  const t = /* @__PURE__ */ Za(e), n = c.forwardRef((o, r) => {
    const { children: s, ...a } = o, i = c.Children.toArray(s), l = i.find(Ja);
    if (l) {
      const u = l.props.children, d = i.map((p) => p === l ? c.Children.count(u) > 1 ? c.Children.only(null) : c.isValidElement(u) ? u.props.children : null : p);
      return /* @__PURE__ */ f(t, { ...a, ref: r, children: c.isValidElement(u) ? c.cloneElement(u, void 0, d) : null });
    }
    return /* @__PURE__ */ f(t, { ...a, ref: r, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Za(e) {
  const t = c.forwardRef((n, o) => {
    const { children: r, ...s } = n;
    if (c.isValidElement(r)) {
      const a = tc(r), i = ec(s, r.props);
      return r.type !== c.Fragment && (i.ref = o ? pt(o, a) : a), c.cloneElement(r, i);
    }
    return c.Children.count(r) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Qa = Symbol("radix.slottable");
function Ja(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Qa;
}
function ec(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], s = t[o];
    /^on[A-Z]/.test(o) ? r && s ? n[o] = (...i) => {
      const l = s(...i);
      return r(...i), l;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...s } : o === "className" && (n[o] = [r, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function tc(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var nc = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], V = nc.reduce((e, t) => {
  const n = /* @__PURE__ */ Ye(`Primitive.${t}`), o = c.forwardRef((r, s) => {
    const { asChild: a, ...i } = r, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(l, { ...i, ref: s });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function jo(e, t) {
  e && Bt.flushSync(() => e.dispatchEvent(t));
}
function ue(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function oc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ue(e);
  c.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var rc = "DismissableLayer", vn = "dismissableLayer.update", sc = "dismissableLayer.pointerDownOutside", ic = "dismissableLayer.focusOutside", io, Yo = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Vt = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: s,
      onInteractOutside: a,
      onDismiss: i,
      ...l
    } = e, u = c.useContext(Yo), [d, p] = c.useState(null), g = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = c.useState({}), b = X(t, (R) => p(R)), m = Array.from(u.layers), [h] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = m.indexOf(h), y = d ? m.indexOf(d) : -1, x = u.layersWithOutsidePointerEventsDisabled.size > 0, C = y >= w, S = lc((R) => {
      const A = R.target, k = [...u.branches].some((D) => D.contains(A));
      !C || k || (r == null || r(R), a == null || a(R), R.defaultPrevented || i == null || i());
    }, g), N = uc((R) => {
      const A = R.target;
      [...u.branches].some((D) => D.contains(A)) || (s == null || s(R), a == null || a(R), R.defaultPrevented || i == null || i());
    }, g);
    return oc((R) => {
      y === u.layers.size - 1 && (o == null || o(R), !R.defaultPrevented && i && (R.preventDefault(), i()));
    }, g), c.useEffect(() => {
      if (d)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (io = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), ao(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = io);
        };
    }, [d, g, n, u]), c.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), ao());
    }, [d, u]), c.useEffect(() => {
      const R = () => v({});
      return document.addEventListener(vn, R), () => document.removeEventListener(vn, R);
    }, []), /* @__PURE__ */ f(
      V.div,
      {
        ...l,
        ref: b,
        style: {
          pointerEvents: x ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: P(e.onFocusCapture, N.onFocusCapture),
        onBlurCapture: P(e.onBlurCapture, N.onBlurCapture),
        onPointerDownCapture: P(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
Vt.displayName = rc;
var ac = "DismissableLayerBranch", cc = c.forwardRef((e, t) => {
  const n = c.useContext(Yo), o = c.useRef(null), r = X(t, o);
  return c.useEffect(() => {
    const s = o.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ f(V.div, { ...e, ref: r });
});
cc.displayName = ac;
function lc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ue(e), o = c.useRef(!1), r = c.useRef(() => {
  });
  return c.useEffect(() => {
    const s = (i) => {
      if (i.target && !o.current) {
        let l = function() {
          Xo(
            sc,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", s), t.removeEventListener("click", r.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function uc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ue(e), o = c.useRef(!1);
  return c.useEffect(() => {
    const r = (s) => {
      s.target && !o.current && Xo(ic, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function ao() {
  const e = new CustomEvent(vn);
  document.dispatchEvent(e);
}
function Xo(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? jo(r, s) : r.dispatchEvent(s);
}
var rn = "focusScope.autoFocusOnMount", sn = "focusScope.autoFocusOnUnmount", co = { bubbles: !1, cancelable: !0 }, dc = "FocusScope", zt = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: s,
    ...a
  } = e, [i, l] = c.useState(null), u = ue(r), d = ue(s), p = c.useRef(null), g = X(t, (m) => l(m)), v = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (o) {
      let m = function(x) {
        if (v.paused || !i) return;
        const C = x.target;
        i.contains(C) ? p.current = C : Me(p.current, { select: !0 });
      }, h = function(x) {
        if (v.paused || !i) return;
        const C = x.relatedTarget;
        C !== null && (i.contains(C) || Me(p.current, { select: !0 }));
      }, w = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && Me(i);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", h);
      const y = new MutationObserver(w);
      return i && y.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", h), y.disconnect();
      };
    }
  }, [o, i, v.paused]), c.useEffect(() => {
    if (i) {
      uo.add(v);
      const m = document.activeElement;
      if (!i.contains(m)) {
        const w = new CustomEvent(rn, co);
        i.addEventListener(rn, u), i.dispatchEvent(w), w.defaultPrevented || (fc(vc(qo(i)), { select: !0 }), document.activeElement === m && Me(i));
      }
      return () => {
        i.removeEventListener(rn, u), setTimeout(() => {
          const w = new CustomEvent(sn, co);
          i.addEventListener(sn, d), i.dispatchEvent(w), w.defaultPrevented || Me(m ?? document.body, { select: !0 }), i.removeEventListener(sn, d), uo.remove(v);
        }, 0);
      };
    }
  }, [i, u, d, v]);
  const b = c.useCallback(
    (m) => {
      if (!n && !o || v.paused) return;
      const h = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, w = document.activeElement;
      if (h && w) {
        const y = m.currentTarget, [x, C] = pc(y);
        x && C ? !m.shiftKey && w === C ? (m.preventDefault(), n && Me(x, { select: !0 })) : m.shiftKey && w === x && (m.preventDefault(), n && Me(C, { select: !0 })) : w === y && m.preventDefault();
      }
    },
    [n, o, v.paused]
  );
  return /* @__PURE__ */ f(V.div, { tabIndex: -1, ...a, ref: g, onKeyDown: b });
});
zt.displayName = dc;
function fc(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (Me(o, { select: t }), document.activeElement !== n) return;
}
function pc(e) {
  const t = qo(e), n = lo(t, e), o = lo(t.reverse(), e);
  return [n, o];
}
function qo(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function lo(e, t) {
  for (const n of e)
    if (!mc(n, { upTo: t })) return n;
}
function mc(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function gc(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Me(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && gc(e) && t && e.select();
  }
}
var uo = hc();
function hc() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = fo(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = fo(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function fo(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function vc(e) {
  return e.filter((t) => t.tagName !== "A");
}
var bc = "Portal", Gt = c.forwardRef((e, t) => {
  var i;
  const { container: n, ...o } = e, [r, s] = c.useState(!1);
  J(() => s(!0), []);
  const a = n || r && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return a ? Yi.createPortal(/* @__PURE__ */ f(V.div, { ...o, ref: t }), a) : null;
});
Gt.displayName = bc;
function wc(e, t) {
  return c.useReducer((n, o) => t[n][o] ?? n, e);
}
var Te = (e) => {
  const { present: t, children: n } = e, o = yc(t), r = typeof n == "function" ? n({ present: o.isPresent }) : c.Children.only(n), s = X(o.ref, xc(r));
  return typeof n == "function" || o.isPresent ? c.cloneElement(r, { ref: s }) : null;
};
Te.displayName = "Presence";
function yc(e) {
  const [t, n] = c.useState(), o = c.useRef(null), r = c.useRef(e), s = c.useRef("none"), a = e ? "mounted" : "unmounted", [i, l] = wc(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    const u = yt(o.current);
    s.current = i === "mounted" ? u : "none";
  }, [i]), J(() => {
    const u = o.current, d = r.current;
    if (d !== e) {
      const g = s.current, v = yt(u);
      e ? l("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && g !== v ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, l]), J(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, p = (v) => {
        const m = yt(o.current).includes(CSS.escape(v.animationName));
        if (v.target === t && m && (l("ANIMATION_END"), !r.current)) {
          const h = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = h);
          });
        }
      }, g = (v) => {
        v.target === t && (s.current = yt(o.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", p), t.addEventListener("animationend", p), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", p), t.removeEventListener("animationend", p);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: c.useCallback((u) => {
      o.current = u ? getComputedStyle(u) : null, n(u);
    }, [])
  };
}
function yt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function xc(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var an = 0;
function Tn() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? po()), document.body.insertAdjacentElement("beforeend", e[1] ?? po()), an++, () => {
      an === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), an--;
    };
  }, []);
}
function po() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ge = function() {
  return ge = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, ge.apply(this, arguments);
};
function Zo(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function Cc(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, r = t.length, s; o < r; o++)
    (s || !(o in t)) && (s || (s = Array.prototype.slice.call(t, 0, o)), s[o] = t[o]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var Nt = "right-scroll-bar-position", Mt = "width-before-scroll-bar", Sc = "with-scroll-bars-hidden", Rc = "--removed-body-scroll-bar-size";
function cn(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Ec(e, t) {
  var n = Ki(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Nc = typeof window < "u" ? c.useLayoutEffect : c.useEffect, mo = /* @__PURE__ */ new WeakMap();
function Mc(e, t) {
  var n = Ec(null, function(o) {
    return e.forEach(function(r) {
      return cn(r, o);
    });
  });
  return Nc(function() {
    var o = mo.get(n);
    if (o) {
      var r = new Set(o), s = new Set(e), a = n.current;
      r.forEach(function(i) {
        s.has(i) || cn(i, null);
      }), s.forEach(function(i) {
        r.has(i) || cn(i, a);
      });
    }
    mo.set(n, e);
  }, [e]), n;
}
function Pc(e) {
  return e;
}
function Ac(e, t) {
  t === void 0 && (t = Pc);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var a = t(s, o);
      return n.push(a), function() {
        n = n.filter(function(i) {
          return i !== a;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (o = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(s);
      }
      n = {
        push: function(i) {
          return s(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      o = !0;
      var a = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(s), a = n;
      }
      var l = function() {
        var d = a;
        a = [], d.forEach(s);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(d) {
          a.push(d), u();
        },
        filter: function(d) {
          return a = a.filter(d), n;
        }
      };
    }
  };
  return r;
}
function Tc(e) {
  e === void 0 && (e = {});
  var t = Ac(null);
  return t.options = ge({ async: !0, ssr: !1 }, e), t;
}
var Qo = function(e) {
  var t = e.sideCar, n = Zo(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return c.createElement(o, ge({}, n));
};
Qo.isSideCarExport = !0;
function Ic(e, t) {
  return e.useMedium(t), Qo;
}
var Jo = Tc(), ln = function() {
}, Ht = c.forwardRef(function(e, t) {
  var n = c.useRef(null), o = c.useState({
    onScrollCapture: ln,
    onWheelCapture: ln,
    onTouchMoveCapture: ln
  }), r = o[0], s = o[1], a = e.forwardProps, i = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, p = e.shards, g = e.sideCar, v = e.noRelative, b = e.noIsolation, m = e.inert, h = e.allowPinchZoom, w = e.as, y = w === void 0 ? "div" : w, x = e.gapMode, C = Zo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = g, N = Mc([n, t]), R = ge(ge({}, C), r);
  return c.createElement(
    c.Fragment,
    null,
    d && c.createElement(S, { sideCar: Jo, removeScrollBar: u, shards: p, noRelative: v, noIsolation: b, inert: m, setCallbacks: s, allowPinchZoom: !!h, lockRef: n, gapMode: x }),
    a ? c.cloneElement(c.Children.only(i), ge(ge({}, R), { ref: N })) : c.createElement(y, ge({}, R, { className: l, ref: N }), i)
  );
});
Ht.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ht.classNames = {
  fullWidth: Mt,
  zeroRight: Nt
};
var _c = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Oc() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = _c();
  return t && e.setAttribute("nonce", t), e;
}
function Dc(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function kc(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Lc = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Oc()) && (Dc(t, n), kc(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Fc = function() {
  var e = Lc();
  return function(t, n) {
    c.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, er = function() {
  var e = Fc(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, $c = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, un = function(e) {
  return parseInt(e || "", 10) || 0;
}, Bc = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [un(n), un(o), un(r)];
}, Wc = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return $c;
  var t = Bc(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, Vc = er(), Ue = "data-scroll-locked", zc = function(e, t, n, o) {
  var r = e.left, s = e.top, a = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Sc, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(i, "px ").concat(o, `;
  }
  body[`).concat(Ue, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Nt, ` {
    right: `).concat(i, "px ").concat(o, `;
  }
  
  .`).concat(Mt, ` {
    margin-right: `).concat(i, "px ").concat(o, `;
  }
  
  .`).concat(Nt, " .").concat(Nt, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(Mt, " .").concat(Mt, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Ue, `] {
    `).concat(Rc, ": ").concat(i, `px;
  }
`);
}, go = function() {
  var e = parseInt(document.body.getAttribute(Ue) || "0", 10);
  return isFinite(e) ? e : 0;
}, Gc = function() {
  c.useEffect(function() {
    return document.body.setAttribute(Ue, (go() + 1).toString()), function() {
      var e = go() - 1;
      e <= 0 ? document.body.removeAttribute(Ue) : document.body.setAttribute(Ue, e.toString());
    };
  }, []);
}, Hc = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o;
  Gc();
  var s = c.useMemo(function() {
    return Wc(r);
  }, [r]);
  return c.createElement(Vc, { styles: zc(s, !t, r, n ? "" : "!important") });
}, bn = !1;
if (typeof window < "u")
  try {
    var xt = Object.defineProperty({}, "passive", {
      get: function() {
        return bn = !0, !0;
      }
    });
    window.addEventListener("test", xt, xt), window.removeEventListener("test", xt, xt);
  } catch {
    bn = !1;
  }
var Ve = bn ? { passive: !1 } : !1, Uc = function(e) {
  return e.tagName === "TEXTAREA";
}, tr = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Uc(e) && n[t] === "visible")
  );
}, Kc = function(e) {
  return tr(e, "overflowY");
}, jc = function(e) {
  return tr(e, "overflowX");
}, ho = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = nr(e, o);
    if (r) {
      var s = or(e, o), a = s[1], i = s[2];
      if (a > i)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, Yc = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, Xc = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, nr = function(e, t) {
  return e === "v" ? Kc(t) : jc(t);
}, or = function(e, t) {
  return e === "v" ? Yc(t) : Xc(t);
}, qc = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Zc = function(e, t, n, o, r) {
  var s = qc(e, window.getComputedStyle(t).direction), a = s * o, i = n.target, l = t.contains(i), u = !1, d = a > 0, p = 0, g = 0;
  do {
    if (!i)
      break;
    var v = or(e, i), b = v[0], m = v[1], h = v[2], w = m - h - s * b;
    (b || w) && nr(e, i) && (p += w, g += b);
    var y = i.parentNode;
    i = y && y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? y.host : y;
  } while (
    // portaled content
    !l && i !== document.body || // self content
    l && (t.contains(i) || t === i)
  );
  return (d && Math.abs(p) < 1 || !d && Math.abs(g) < 1) && (u = !0), u;
}, Ct = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, vo = function(e) {
  return [e.deltaX, e.deltaY];
}, bo = function(e) {
  return e && "current" in e ? e.current : e;
}, Qc = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Jc = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, el = 0, ze = [];
function tl(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), o = c.useRef(), r = c.useState(el++)[0], s = c.useState(er)[0], a = c.useRef(e);
  c.useEffect(function() {
    a.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var m = Cc([e.lockRef.current], (e.shards || []).map(bo), !0).filter(Boolean);
      return m.forEach(function(h) {
        return h.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), m.forEach(function(h) {
          return h.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = c.useCallback(function(m, h) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !a.current.allowPinchZoom;
    var w = Ct(m), y = n.current, x = "deltaX" in m ? m.deltaX : y[0] - w[0], C = "deltaY" in m ? m.deltaY : y[1] - w[1], S, N = m.target, R = Math.abs(x) > Math.abs(C) ? "h" : "v";
    if ("touches" in m && R === "h" && N.type === "range")
      return !1;
    var A = window.getSelection(), k = A && A.anchorNode, D = k ? k === N || k.contains(N) : !1;
    if (D)
      return !1;
    var $ = ho(R, N);
    if (!$)
      return !0;
    if ($ ? S = R : (S = R === "v" ? "h" : "v", $ = ho(R, N)), !$)
      return !1;
    if (!o.current && "changedTouches" in m && (x || C) && (o.current = S), !S)
      return !0;
    var M = o.current || S;
    return Zc(M, h, m, M === "h" ? x : C);
  }, []), l = c.useCallback(function(m) {
    var h = m;
    if (!(!ze.length || ze[ze.length - 1] !== s)) {
      var w = "deltaY" in h ? vo(h) : Ct(h), y = t.current.filter(function(S) {
        return S.name === h.type && (S.target === h.target || h.target === S.shadowParent) && Qc(S.delta, w);
      })[0];
      if (y && y.should) {
        h.cancelable && h.preventDefault();
        return;
      }
      if (!y) {
        var x = (a.current.shards || []).map(bo).filter(Boolean).filter(function(S) {
          return S.contains(h.target);
        }), C = x.length > 0 ? i(h, x[0]) : !a.current.noIsolation;
        C && h.cancelable && h.preventDefault();
      }
    }
  }, []), u = c.useCallback(function(m, h, w, y) {
    var x = { name: m, delta: h, target: w, should: y, shadowParent: nl(w) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== x;
      });
    }, 1);
  }, []), d = c.useCallback(function(m) {
    n.current = Ct(m), o.current = void 0;
  }, []), p = c.useCallback(function(m) {
    u(m.type, vo(m), m.target, i(m, e.lockRef.current));
  }, []), g = c.useCallback(function(m) {
    u(m.type, Ct(m), m.target, i(m, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return ze.push(s), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", l, Ve), document.addEventListener("touchmove", l, Ve), document.addEventListener("touchstart", d, Ve), function() {
      ze = ze.filter(function(m) {
        return m !== s;
      }), document.removeEventListener("wheel", l, Ve), document.removeEventListener("touchmove", l, Ve), document.removeEventListener("touchstart", d, Ve);
    };
  }, []);
  var v = e.removeScrollBar, b = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    b ? c.createElement(s, { styles: Jc(r) }) : null,
    v ? c.createElement(Hc, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function nl(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const ol = Ic(Jo, tl);
var Ut = c.forwardRef(function(e, t) {
  return c.createElement(Ht, ge({}, e, { ref: t, sideCar: ol }));
});
Ut.classNames = Ht.classNames;
var rl = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Ge = /* @__PURE__ */ new WeakMap(), St = /* @__PURE__ */ new WeakMap(), Rt = {}, dn = 0, rr = function(e) {
  return e && (e.host || rr(e.parentNode));
}, sl = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = rr(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, il = function(e, t, n, o) {
  var r = sl(t, Array.isArray(e) ? e : [e]);
  Rt[n] || (Rt[n] = /* @__PURE__ */ new WeakMap());
  var s = Rt[n], a = [], i = /* @__PURE__ */ new Set(), l = new Set(r), u = function(p) {
    !p || i.has(p) || (i.add(p), u(p.parentNode));
  };
  r.forEach(u);
  var d = function(p) {
    !p || l.has(p) || Array.prototype.forEach.call(p.children, function(g) {
      if (i.has(g))
        d(g);
      else
        try {
          var v = g.getAttribute(o), b = v !== null && v !== "false", m = (Ge.get(g) || 0) + 1, h = (s.get(g) || 0) + 1;
          Ge.set(g, m), s.set(g, h), a.push(g), m === 1 && b && St.set(g, !0), h === 1 && g.setAttribute(n, "true"), b || g.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", g, w);
        }
    });
  };
  return d(t), i.clear(), dn++, function() {
    a.forEach(function(p) {
      var g = Ge.get(p) - 1, v = s.get(p) - 1;
      Ge.set(p, g), s.set(p, v), g || (St.has(p) || p.removeAttribute(o), St.delete(p)), v || p.removeAttribute(n);
    }), dn--, dn || (Ge = /* @__PURE__ */ new WeakMap(), Ge = /* @__PURE__ */ new WeakMap(), St = /* @__PURE__ */ new WeakMap(), Rt = {});
  };
}, In = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = rl(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live], script"))), il(o, r, n, "aria-hidden")) : function() {
    return null;
  };
}, Kt = "Dialog", [sr] = Be(Kt), [al, pe] = sr(Kt), ir = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: s,
    modal: a = !0
  } = e, i = c.useRef(null), l = c.useRef(null), [u, d] = je({
    prop: o,
    defaultProp: r ?? !1,
    onChange: s,
    caller: Kt
  });
  return /* @__PURE__ */ f(
    al,
    {
      scope: t,
      triggerRef: i,
      contentRef: l,
      contentId: le(),
      titleId: le(),
      descriptionId: le(),
      open: u,
      onOpenChange: d,
      onOpenToggle: c.useCallback(() => d((p) => !p), [d]),
      modal: a,
      children: n
    }
  );
};
ir.displayName = Kt;
var ar = "DialogTrigger", cr = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = pe(ar, n), s = X(t, r.triggerRef);
    return /* @__PURE__ */ f(
      V.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": Dn(r.open),
        ...o,
        ref: s,
        onClick: P(e.onClick, r.onOpenToggle)
      }
    );
  }
);
cr.displayName = ar;
var _n = "DialogPortal", [cl, lr] = sr(_n, {
  forceMount: void 0
}), ur = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: r } = e, s = pe(_n, t);
  return /* @__PURE__ */ f(cl, { scope: t, forceMount: n, children: c.Children.map(o, (a) => /* @__PURE__ */ f(Te, { present: n || s.open, children: /* @__PURE__ */ f(Gt, { asChild: !0, container: r, children: a }) })) });
};
ur.displayName = _n;
var Tt = "DialogOverlay", dr = c.forwardRef(
  (e, t) => {
    const n = lr(Tt, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, s = pe(Tt, e.__scopeDialog);
    return s.modal ? /* @__PURE__ */ f(Te, { present: o || s.open, children: /* @__PURE__ */ f(ul, { ...r, ref: t }) }) : null;
  }
);
dr.displayName = Tt;
var ll = /* @__PURE__ */ Ye("DialogOverlay.RemoveScroll"), ul = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = pe(Tt, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ f(Ut, { as: ll, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ f(
        V.div,
        {
          "data-state": Dn(r.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), ke = "DialogContent", fr = c.forwardRef(
  (e, t) => {
    const n = lr(ke, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, s = pe(ke, e.__scopeDialog);
    return /* @__PURE__ */ f(Te, { present: o || s.open, children: s.modal ? /* @__PURE__ */ f(dl, { ...r, ref: t }) : /* @__PURE__ */ f(fl, { ...r, ref: t }) });
  }
);
fr.displayName = ke;
var dl = c.forwardRef(
  (e, t) => {
    const n = pe(ke, e.__scopeDialog), o = c.useRef(null), r = X(t, n.contentRef, o);
    return c.useEffect(() => {
      const s = o.current;
      if (s) return In(s);
    }, []), /* @__PURE__ */ f(
      pr,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: P(e.onCloseAutoFocus, (s) => {
          var a;
          s.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: P(e.onPointerDownOutside, (s) => {
          const a = s.detail.originalEvent, i = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || i) && s.preventDefault();
        }),
        onFocusOutside: P(
          e.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), fl = c.forwardRef(
  (e, t) => {
    const n = pe(ke, e.__scopeDialog), o = c.useRef(!1), r = c.useRef(!1);
    return /* @__PURE__ */ f(
      pr,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var a, i;
          (a = e.onCloseAutoFocus) == null || a.call(e, s), s.defaultPrevented || (o.current || (i = n.triggerRef.current) == null || i.focus(), s.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (s) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, s), s.defaultPrevented || (o.current = !0, s.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const a = s.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(a)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && r.current && s.preventDefault();
        }
      }
    );
  }
), pr = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: s, ...a } = e, i = pe(ke, n), l = c.useRef(null), u = X(t, l);
    return Tn(), /* @__PURE__ */ Q(ct, { children: [
      /* @__PURE__ */ f(
        zt,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: r,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ f(
            Vt,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": Dn(i.open),
              ...a,
              ref: u,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ Q(ct, { children: [
        /* @__PURE__ */ f(pl, { titleId: i.titleId }),
        /* @__PURE__ */ f(gl, { contentRef: l, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), On = "DialogTitle", mr = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = pe(On, n);
    return /* @__PURE__ */ f(V.h2, { id: r.titleId, ...o, ref: t });
  }
);
mr.displayName = On;
var gr = "DialogDescription", hr = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = pe(gr, n);
    return /* @__PURE__ */ f(V.p, { id: r.descriptionId, ...o, ref: t });
  }
);
hr.displayName = gr;
var vr = "DialogClose", br = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = pe(vr, n);
    return /* @__PURE__ */ f(
      V.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: P(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
br.displayName = vr;
function Dn(e) {
  return e ? "open" : "closed";
}
var wr = "DialogTitleWarning", [$p, yr] = Ha(wr, {
  contentName: ke,
  titleName: On,
  docsSlug: "dialog"
}), pl = ({ titleId: e }) => {
  const t = yr(wr), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return c.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, ml = "DialogDescriptionWarning", gl = ({ contentRef: e, descriptionId: t }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${yr(ml).contentName}}.`;
  return c.useEffect(() => {
    var s;
    const r = (s = e.current) == null ? void 0 : s.getAttribute("aria-describedby");
    t && r && (document.getElementById(t) || console.warn(o));
  }, [o, e, t]), null;
}, hl = ir, vl = cr, bl = ur, xr = dr, Cr = fr, Sr = mr, Rr = hr, Er = br;
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wl = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Nr = (...e) => e.filter((t, n, o) => !!t && t.trim() !== "" && o.indexOf(t) === n).join(" ").trim();
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var yl = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xl = _o(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: o,
    className: r = "",
    children: s,
    iconNode: a,
    ...i
  }, l) => gn(
    "svg",
    {
      ref: l,
      ...yl,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: o ? Number(n) * 24 / Number(t) : n,
      className: Nr("lucide", r),
      ...i
    },
    [
      ...a.map(([u, d]) => gn(u, d)),
      ...Array.isArray(s) ? s : [s]
    ]
  )
);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ze = (e, t) => {
  const n = _o(
    ({ className: o, ...r }, s) => gn(xl, {
      ref: s,
      iconNode: t,
      className: Nr(`lucide-${wl(e)}`, o),
      ...r
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mr = Ze("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pr = Ze("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cl = Ze("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sl = Ze("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rl = Ze("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const El = Ze("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), Bp = hl, Wp = vl, Nl = bl, Vp = Er, Ar = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  xr,
  {
    ref: n,
    className: I(
      "fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Ar.displayName = xr.displayName;
const Ml = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ Q(Nl, { children: [
  /* @__PURE__ */ f(Ar, {}),
  /* @__PURE__ */ Q(
    Cr,
    {
      ref: o,
      className: I(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ Q(Er, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ f(El, { className: "h-4 w-4" }),
          /* @__PURE__ */ f("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Ml.displayName = Cr.displayName;
const Pl = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "div",
  {
    className: I(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...t
  }
);
Pl.displayName = "DialogHeader";
const Al = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "div",
  {
    className: I(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
Al.displayName = "DialogFooter";
const Tl = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Sr,
  {
    ref: n,
    className: I(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
Tl.displayName = Sr.displayName;
const Il = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Rr,
  {
    ref: n,
    className: I("text-sm text-muted-foreground", e),
    ...t
  }
));
Il.displayName = Rr.displayName;
function kn(e) {
  const t = e + "CollectionProvider", [n, o] = Be(t), [r, s] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: h, children: w } = m, y = De.useRef(null), x = De.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ f(r, { scope: h, itemMap: x, collectionRef: y, children: w });
  };
  a.displayName = t;
  const i = e + "CollectionSlot", l = /* @__PURE__ */ Ye(i), u = De.forwardRef(
    (m, h) => {
      const { scope: w, children: y } = m, x = s(i, w), C = X(h, x.collectionRef);
      return /* @__PURE__ */ f(l, { ref: C, children: y });
    }
  );
  u.displayName = i;
  const d = e + "CollectionItemSlot", p = "data-radix-collection-item", g = /* @__PURE__ */ Ye(d), v = De.forwardRef(
    (m, h) => {
      const { scope: w, children: y, ...x } = m, C = De.useRef(null), S = X(h, C), N = s(d, w);
      return De.useEffect(() => (N.itemMap.set(C, { ref: C, ...x }), () => void N.itemMap.delete(C))), /* @__PURE__ */ f(g, { [p]: "", ref: S, children: y });
    }
  );
  v.displayName = d;
  function b(m) {
    const h = s(e + "CollectionConsumer", m);
    return De.useCallback(() => {
      const y = h.collectionRef.current;
      if (!y) return [];
      const x = Array.from(y.querySelectorAll(`[${p}]`));
      return Array.from(h.itemMap.values()).sort(
        (N, R) => x.indexOf(N.ref.current) - x.indexOf(R.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: a, Slot: u, ItemSlot: v },
    b,
    o
  ];
}
var _l = c.createContext(void 0);
function Ln(e) {
  const t = c.useContext(_l);
  return e || t || "ltr";
}
const Ol = ["top", "right", "bottom", "left"], Pe = Math.min, re = Math.max, It = Math.round, Et = Math.floor, ve = (e) => ({
  x: e,
  y: e
}), Dl = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, kl = {
  start: "end",
  end: "start"
};
function wn(e, t, n) {
  return re(e, Pe(t, n));
}
function Se(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Re(e) {
  return e.split("-")[0];
}
function Qe(e) {
  return e.split("-")[1];
}
function Fn(e) {
  return e === "x" ? "y" : "x";
}
function $n(e) {
  return e === "y" ? "height" : "width";
}
const Ll = /* @__PURE__ */ new Set(["top", "bottom"]);
function he(e) {
  return Ll.has(Re(e)) ? "y" : "x";
}
function Bn(e) {
  return Fn(he(e));
}
function Fl(e, t, n) {
  n === void 0 && (n = !1);
  const o = Qe(e), r = Bn(e), s = $n(r);
  let a = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (a = _t(a)), [a, _t(a)];
}
function $l(e) {
  const t = _t(e);
  return [yn(e), t, yn(t)];
}
function yn(e) {
  return e.replace(/start|end/g, (t) => kl[t]);
}
const wo = ["left", "right"], yo = ["right", "left"], Bl = ["top", "bottom"], Wl = ["bottom", "top"];
function Vl(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? yo : wo : t ? wo : yo;
    case "left":
    case "right":
      return t ? Bl : Wl;
    default:
      return [];
  }
}
function zl(e, t, n, o) {
  const r = Qe(e);
  let s = Vl(Re(e), n === "start", o);
  return r && (s = s.map((a) => a + "-" + r), t && (s = s.concat(s.map(yn)))), s;
}
function _t(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Dl[t]);
}
function Gl(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Tr(e) {
  return typeof e != "number" ? Gl(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ot(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function xo(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const s = he(t), a = Bn(t), i = $n(a), l = Re(t), u = s === "y", d = o.x + o.width / 2 - r.width / 2, p = o.y + o.height / 2 - r.height / 2, g = o[i] / 2 - r[i] / 2;
  let v;
  switch (l) {
    case "top":
      v = {
        x: d,
        y: o.y - r.height
      };
      break;
    case "bottom":
      v = {
        x: d,
        y: o.y + o.height
      };
      break;
    case "right":
      v = {
        x: o.x + o.width,
        y: p
      };
      break;
    case "left":
      v = {
        x: o.x - r.width,
        y: p
      };
      break;
    default:
      v = {
        x: o.x,
        y: o.y
      };
  }
  switch (Qe(t)) {
    case "start":
      v[a] -= g * (n && u ? -1 : 1);
      break;
    case "end":
      v[a] += g * (n && u ? -1 : 1);
      break;
  }
  return v;
}
const Hl = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: a
  } = n, i = s.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: d,
    y: p
  } = xo(u, o, l), g = o, v = {}, b = 0;
  for (let m = 0; m < i.length; m++) {
    const {
      name: h,
      fn: w
    } = i[m], {
      x: y,
      y: x,
      data: C,
      reset: S
    } = await w({
      x: d,
      y: p,
      initialPlacement: o,
      placement: g,
      strategy: r,
      middlewareData: v,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = y ?? d, p = x ?? p, v = {
      ...v,
      [h]: {
        ...v[h],
        ...C
      }
    }, S && b <= 50 && (b++, typeof S == "object" && (S.placement && (g = S.placement), S.rects && (u = S.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : S.rects), {
      x: d,
      y: p
    } = xo(u, g, l)), m = -1);
  }
  return {
    x: d,
    y: p,
    placement: g,
    strategy: r,
    middlewareData: v
  };
};
async function lt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: s,
    rects: a,
    elements: i,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: p = "floating",
    altBoundary: g = !1,
    padding: v = 0
  } = Se(t, e), b = Tr(v), h = i[g ? p === "floating" ? "reference" : "floating" : p], w = Ot(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(h))) == null || n ? h : h.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), y = p === "floating" ? {
    x: o,
    y: r,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(i.floating)), C = await (s.isElement == null ? void 0 : s.isElement(x)) ? await (s.getScale == null ? void 0 : s.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Ot(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: y,
    offsetParent: x,
    strategy: l
  }) : y);
  return {
    top: (w.top - S.top + b.top) / C.y,
    bottom: (S.bottom - w.bottom + b.bottom) / C.y,
    left: (w.left - S.left + b.left) / C.x,
    right: (S.right - w.right + b.right) / C.x
  };
}
const Ul = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: s,
      platform: a,
      elements: i,
      middlewareData: l
    } = t, {
      element: u,
      padding: d = 0
    } = Se(e, t) || {};
    if (u == null)
      return {};
    const p = Tr(d), g = {
      x: n,
      y: o
    }, v = Bn(r), b = $n(v), m = await a.getDimensions(u), h = v === "y", w = h ? "top" : "left", y = h ? "bottom" : "right", x = h ? "clientHeight" : "clientWidth", C = s.reference[b] + s.reference[v] - g[v] - s.floating[b], S = g[v] - s.reference[v], N = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let R = N ? N[x] : 0;
    (!R || !await (a.isElement == null ? void 0 : a.isElement(N))) && (R = i.floating[x] || s.floating[b]);
    const A = C / 2 - S / 2, k = R / 2 - m[b] / 2 - 1, D = Pe(p[w], k), $ = Pe(p[y], k), M = D, B = R - m[b] - $, L = R / 2 - m[b] / 2 + A, z = wn(M, L, B), O = !l.arrow && Qe(r) != null && L !== z && s.reference[b] / 2 - (L < M ? D : $) - m[b] / 2 < 0, W = O ? L < M ? L - M : L - B : 0;
    return {
      [v]: g[v] + W,
      data: {
        [v]: z,
        centerOffset: L - z - W,
        ...O && {
          alignmentOffset: W
        }
      },
      reset: O
    };
  }
}), Kl = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: s,
        rects: a,
        initialPlacement: i,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: p = !0,
        fallbackPlacements: g,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: m = !0,
        ...h
      } = Se(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const w = Re(r), y = he(i), x = Re(i) === i, C = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), S = g || (x || !m ? [_t(i)] : $l(i)), N = b !== "none";
      !g && N && S.push(...zl(i, m, b, C));
      const R = [i, ...S], A = await lt(t, h), k = [];
      let D = ((o = s.flip) == null ? void 0 : o.overflows) || [];
      if (d && k.push(A[w]), p) {
        const L = Fl(r, a, C);
        k.push(A[L[0]], A[L[1]]);
      }
      if (D = [...D, {
        placement: r,
        overflows: k
      }], !k.every((L) => L <= 0)) {
        var $, M;
        const L = ((($ = s.flip) == null ? void 0 : $.index) || 0) + 1, z = R[L];
        if (z && (!(p === "alignment" ? y !== he(z) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        D.every((T) => he(T.placement) === y ? T.overflows[0] > 0 : !0)))
          return {
            data: {
              index: L,
              overflows: D
            },
            reset: {
              placement: z
            }
          };
        let O = (M = D.filter((W) => W.overflows[0] <= 0).sort((W, T) => W.overflows[1] - T.overflows[1])[0]) == null ? void 0 : M.placement;
        if (!O)
          switch (v) {
            case "bestFit": {
              var B;
              const W = (B = D.filter((T) => {
                if (N) {
                  const E = he(T.placement);
                  return E === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  E === "y";
                }
                return !0;
              }).map((T) => [T.placement, T.overflows.filter((E) => E > 0).reduce((E, G) => E + G, 0)]).sort((T, E) => T[1] - E[1])[0]) == null ? void 0 : B[0];
              W && (O = W);
              break;
            }
            case "initialPlacement":
              O = i;
              break;
          }
        if (r !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
function Co(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function So(e) {
  return Ol.some((t) => e[t] >= 0);
}
const jl = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...r
      } = Se(e, t);
      switch (o) {
        case "referenceHidden": {
          const s = await lt(t, {
            ...r,
            elementContext: "reference"
          }), a = Co(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: So(a)
            }
          };
        }
        case "escaped": {
          const s = await lt(t, {
            ...r,
            altBoundary: !0
          }), a = Co(s, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: So(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Ir = /* @__PURE__ */ new Set(["left", "top"]);
async function Yl(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, s = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), a = Re(n), i = Qe(n), l = he(n) === "y", u = Ir.has(a) ? -1 : 1, d = s && l ? -1 : 1, p = Se(t, e);
  let {
    mainAxis: g,
    crossAxis: v,
    alignmentAxis: b
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return i && typeof b == "number" && (v = i === "end" ? b * -1 : b), l ? {
    x: v * d,
    y: g * u
  } : {
    x: g * u,
    y: v * d
  };
}
const Xl = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: s,
        placement: a,
        middlewareData: i
      } = t, l = await Yl(t, e);
      return a === ((n = i.offset) == null ? void 0 : n.placement) && (o = i.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, ql = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r
      } = t, {
        mainAxis: s = !0,
        crossAxis: a = !1,
        limiter: i = {
          fn: (h) => {
            let {
              x: w,
              y
            } = h;
            return {
              x: w,
              y
            };
          }
        },
        ...l
      } = Se(e, t), u = {
        x: n,
        y: o
      }, d = await lt(t, l), p = he(Re(r)), g = Fn(p);
      let v = u[g], b = u[p];
      if (s) {
        const h = g === "y" ? "top" : "left", w = g === "y" ? "bottom" : "right", y = v + d[h], x = v - d[w];
        v = wn(y, v, x);
      }
      if (a) {
        const h = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", y = b + d[h], x = b - d[w];
        b = wn(y, b, x);
      }
      const m = i.fn({
        ...t,
        [g]: v,
        [p]: b
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - o,
          enabled: {
            [g]: s,
            [p]: a
          }
        }
      };
    }
  };
}, Zl = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: s,
        middlewareData: a
      } = t, {
        offset: i = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = Se(e, t), d = {
        x: n,
        y: o
      }, p = he(r), g = Fn(p);
      let v = d[g], b = d[p];
      const m = Se(i, t), h = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const x = g === "y" ? "height" : "width", C = s.reference[g] - s.floating[x] + h.mainAxis, S = s.reference[g] + s.reference[x] - h.mainAxis;
        v < C ? v = C : v > S && (v = S);
      }
      if (u) {
        var w, y;
        const x = g === "y" ? "width" : "height", C = Ir.has(Re(r)), S = s.reference[p] - s.floating[x] + (C && ((w = a.offset) == null ? void 0 : w[p]) || 0) + (C ? 0 : h.crossAxis), N = s.reference[p] + s.reference[x] + (C ? 0 : ((y = a.offset) == null ? void 0 : y[p]) || 0) - (C ? h.crossAxis : 0);
        b < S ? b = S : b > N && (b = N);
      }
      return {
        [g]: v,
        [p]: b
      };
    }
  };
}, Ql = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        rects: s,
        platform: a,
        elements: i
      } = t, {
        apply: l = () => {
        },
        ...u
      } = Se(e, t), d = await lt(t, u), p = Re(r), g = Qe(r), v = he(r) === "y", {
        width: b,
        height: m
      } = s.floating;
      let h, w;
      p === "top" || p === "bottom" ? (h = p, w = g === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (w = p, h = g === "end" ? "top" : "bottom");
      const y = m - d.top - d.bottom, x = b - d.left - d.right, C = Pe(m - d[h], y), S = Pe(b - d[w], x), N = !t.middlewareData.shift;
      let R = C, A = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (A = x), (o = t.middlewareData.shift) != null && o.enabled.y && (R = y), N && !g) {
        const D = re(d.left, 0), $ = re(d.right, 0), M = re(d.top, 0), B = re(d.bottom, 0);
        v ? A = b - 2 * (D !== 0 || $ !== 0 ? D + $ : re(d.left, d.right)) : R = m - 2 * (M !== 0 || B !== 0 ? M + B : re(d.top, d.bottom));
      }
      await l({
        ...t,
        availableWidth: A,
        availableHeight: R
      });
      const k = await a.getDimensions(i.floating);
      return b !== k.width || m !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function jt() {
  return typeof window < "u";
}
function Je(e) {
  return _r(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function se(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function we(e) {
  var t;
  return (t = (_r(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function _r(e) {
  return jt() ? e instanceof Node || e instanceof se(e).Node : !1;
}
function de(e) {
  return jt() ? e instanceof Element || e instanceof se(e).Element : !1;
}
function be(e) {
  return jt() ? e instanceof HTMLElement || e instanceof se(e).HTMLElement : !1;
}
function Ro(e) {
  return !jt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof se(e).ShadowRoot;
}
const Jl = /* @__PURE__ */ new Set(["inline", "contents"]);
function mt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = fe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !Jl.has(r);
}
const eu = /* @__PURE__ */ new Set(["table", "td", "th"]);
function tu(e) {
  return eu.has(Je(e));
}
const nu = [":popover-open", ":modal"];
function Yt(e) {
  return nu.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const ou = ["transform", "translate", "scale", "rotate", "perspective"], ru = ["transform", "translate", "scale", "rotate", "perspective", "filter"], su = ["paint", "layout", "strict", "content"];
function Wn(e) {
  const t = Vn(), n = de(e) ? fe(e) : e;
  return ou.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ru.some((o) => (n.willChange || "").includes(o)) || su.some((o) => (n.contain || "").includes(o));
}
function iu(e) {
  let t = Ae(e);
  for (; be(t) && !Xe(t); ) {
    if (Wn(t))
      return t;
    if (Yt(t))
      return null;
    t = Ae(t);
  }
  return null;
}
function Vn() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const au = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Xe(e) {
  return au.has(Je(e));
}
function fe(e) {
  return se(e).getComputedStyle(e);
}
function Xt(e) {
  return de(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ae(e) {
  if (Je(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ro(e) && e.host || // Fallback.
    we(e)
  );
  return Ro(t) ? t.host : t;
}
function Or(e) {
  const t = Ae(e);
  return Xe(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : be(t) && mt(t) ? t : Or(t);
}
function ut(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = Or(e), s = r === ((o = e.ownerDocument) == null ? void 0 : o.body), a = se(r);
  if (s) {
    const i = xn(a);
    return t.concat(a, a.visualViewport || [], mt(r) ? r : [], i && n ? ut(i) : []);
  }
  return t.concat(r, ut(r, [], n));
}
function xn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Dr(e) {
  const t = fe(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = be(e), s = r ? e.offsetWidth : n, a = r ? e.offsetHeight : o, i = It(n) !== s || It(o) !== a;
  return i && (n = s, o = a), {
    width: n,
    height: o,
    $: i
  };
}
function zn(e) {
  return de(e) ? e : e.contextElement;
}
function Ke(e) {
  const t = zn(e);
  if (!be(t))
    return ve(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: s
  } = Dr(t);
  let a = (s ? It(n.width) : n.width) / o, i = (s ? It(n.height) : n.height) / r;
  return (!a || !Number.isFinite(a)) && (a = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: a,
    y: i
  };
}
const cu = /* @__PURE__ */ ve(0);
function kr(e) {
  const t = se(e);
  return !Vn() || !t.visualViewport ? cu : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function lu(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== se(e) ? !1 : t;
}
function Le(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), s = zn(e);
  let a = ve(1);
  t && (o ? de(o) && (a = Ke(o)) : a = Ke(e));
  const i = lu(s, n, o) ? kr(s) : ve(0);
  let l = (r.left + i.x) / a.x, u = (r.top + i.y) / a.y, d = r.width / a.x, p = r.height / a.y;
  if (s) {
    const g = se(s), v = o && de(o) ? se(o) : o;
    let b = g, m = xn(b);
    for (; m && o && v !== b; ) {
      const h = Ke(m), w = m.getBoundingClientRect(), y = fe(m), x = w.left + (m.clientLeft + parseFloat(y.paddingLeft)) * h.x, C = w.top + (m.clientTop + parseFloat(y.paddingTop)) * h.y;
      l *= h.x, u *= h.y, d *= h.x, p *= h.y, l += x, u += C, b = se(m), m = xn(b);
    }
  }
  return Ot({
    width: d,
    height: p,
    x: l,
    y: u
  });
}
function qt(e, t) {
  const n = Xt(e).scrollLeft;
  return t ? t.left + n : Le(we(e)).left + n;
}
function Lr(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - qt(e, n), r = n.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function uu(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const s = r === "fixed", a = we(o), i = t ? Yt(t.floating) : !1;
  if (o === a || i && s)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = ve(1);
  const d = ve(0), p = be(o);
  if ((p || !p && !s) && ((Je(o) !== "body" || mt(a)) && (l = Xt(o)), be(o))) {
    const v = Le(o);
    u = Ke(o), d.x = v.x + o.clientLeft, d.y = v.y + o.clientTop;
  }
  const g = a && !p && !s ? Lr(a, l) : ve(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + d.x + g.x,
    y: n.y * u.y - l.scrollTop * u.y + d.y + g.y
  };
}
function du(e) {
  return Array.from(e.getClientRects());
}
function fu(e) {
  const t = we(e), n = Xt(e), o = e.ownerDocument.body, r = re(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), s = re(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let a = -n.scrollLeft + qt(e);
  const i = -n.scrollTop;
  return fe(o).direction === "rtl" && (a += re(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: s,
    x: a,
    y: i
  };
}
const Eo = 25;
function pu(e, t) {
  const n = se(e), o = we(e), r = n.visualViewport;
  let s = o.clientWidth, a = o.clientHeight, i = 0, l = 0;
  if (r) {
    s = r.width, a = r.height;
    const d = Vn();
    (!d || d && t === "fixed") && (i = r.offsetLeft, l = r.offsetTop);
  }
  const u = qt(o);
  if (u <= 0) {
    const d = o.ownerDocument, p = d.body, g = getComputedStyle(p), v = d.compatMode === "CSS1Compat" && parseFloat(g.marginLeft) + parseFloat(g.marginRight) || 0, b = Math.abs(o.clientWidth - p.clientWidth - v);
    b <= Eo && (s -= b);
  } else u <= Eo && (s += u);
  return {
    width: s,
    height: a,
    x: i,
    y: l
  };
}
const mu = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function gu(e, t) {
  const n = Le(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, s = be(e) ? Ke(e) : ve(1), a = e.clientWidth * s.x, i = e.clientHeight * s.y, l = r * s.x, u = o * s.y;
  return {
    width: a,
    height: i,
    x: l,
    y: u
  };
}
function No(e, t, n) {
  let o;
  if (t === "viewport")
    o = pu(e, n);
  else if (t === "document")
    o = fu(we(e));
  else if (de(t))
    o = gu(t, n);
  else {
    const r = kr(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return Ot(o);
}
function Fr(e, t) {
  const n = Ae(e);
  return n === t || !de(n) || Xe(n) ? !1 : fe(n).position === "fixed" || Fr(n, t);
}
function hu(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = ut(e, [], !1).filter((i) => de(i) && Je(i) !== "body"), r = null;
  const s = fe(e).position === "fixed";
  let a = s ? Ae(e) : e;
  for (; de(a) && !Xe(a); ) {
    const i = fe(a), l = Wn(a);
    !l && i.position === "fixed" && (r = null), (s ? !l && !r : !l && i.position === "static" && !!r && mu.has(r.position) || mt(a) && !l && Fr(e, a)) ? o = o.filter((d) => d !== a) : r = i, a = Ae(a);
  }
  return t.set(e, o), o;
}
function vu(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const a = [...n === "clippingAncestors" ? Yt(t) ? [] : hu(t, this._c) : [].concat(n), o], i = a[0], l = a.reduce((u, d) => {
    const p = No(t, d, r);
    return u.top = re(p.top, u.top), u.right = Pe(p.right, u.right), u.bottom = Pe(p.bottom, u.bottom), u.left = re(p.left, u.left), u;
  }, No(t, i, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function bu(e) {
  const {
    width: t,
    height: n
  } = Dr(e);
  return {
    width: t,
    height: n
  };
}
function wu(e, t, n) {
  const o = be(t), r = we(t), s = n === "fixed", a = Le(e, !0, s, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = ve(0);
  function u() {
    l.x = qt(r);
  }
  if (o || !o && !s)
    if ((Je(t) !== "body" || mt(r)) && (i = Xt(t)), o) {
      const v = Le(t, !0, s, t);
      l.x = v.x + t.clientLeft, l.y = v.y + t.clientTop;
    } else r && u();
  s && !o && r && u();
  const d = r && !o && !s ? Lr(r, i) : ve(0), p = a.left + i.scrollLeft - l.x - d.x, g = a.top + i.scrollTop - l.y - d.y;
  return {
    x: p,
    y: g,
    width: a.width,
    height: a.height
  };
}
function fn(e) {
  return fe(e).position === "static";
}
function Mo(e, t) {
  if (!be(e) || fe(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return we(e) === n && (n = n.ownerDocument.body), n;
}
function $r(e, t) {
  const n = se(e);
  if (Yt(e))
    return n;
  if (!be(e)) {
    let r = Ae(e);
    for (; r && !Xe(r); ) {
      if (de(r) && !fn(r))
        return r;
      r = Ae(r);
    }
    return n;
  }
  let o = Mo(e, t);
  for (; o && tu(o) && fn(o); )
    o = Mo(o, t);
  return o && Xe(o) && fn(o) && !Wn(o) ? n : o || iu(e) || n;
}
const yu = async function(e) {
  const t = this.getOffsetParent || $r, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: wu(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function xu(e) {
  return fe(e).direction === "rtl";
}
const Cu = {
  convertOffsetParentRelativeRectToViewportRelativeRect: uu,
  getDocumentElement: we,
  getClippingRect: vu,
  getOffsetParent: $r,
  getElementRects: yu,
  getClientRects: du,
  getDimensions: bu,
  getScale: Ke,
  isElement: de,
  isRTL: xu
};
function Br(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Su(e, t) {
  let n = null, o;
  const r = we(e);
  function s() {
    var i;
    clearTimeout(o), (i = n) == null || i.disconnect(), n = null;
  }
  function a(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), s();
    const u = e.getBoundingClientRect(), {
      left: d,
      top: p,
      width: g,
      height: v
    } = u;
    if (i || t(), !g || !v)
      return;
    const b = Et(p), m = Et(r.clientWidth - (d + g)), h = Et(r.clientHeight - (p + v)), w = Et(d), x = {
      rootMargin: -b + "px " + -m + "px " + -h + "px " + -w + "px",
      threshold: re(0, Pe(1, l)) || 1
    };
    let C = !0;
    function S(N) {
      const R = N[0].intersectionRatio;
      if (R !== l) {
        if (!C)
          return a();
        R ? a(!1, R) : o = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      R === 1 && !Br(u, e.getBoundingClientRect()) && a(), C = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...x,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, x);
    }
    n.observe(e);
  }
  return a(!0), s;
}
function Ru(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: s = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, u = zn(e), d = r || s ? [...u ? ut(u) : [], ...ut(t)] : [];
  d.forEach((w) => {
    r && w.addEventListener("scroll", n, {
      passive: !0
    }), s && w.addEventListener("resize", n);
  });
  const p = u && i ? Su(u, n) : null;
  let g = -1, v = null;
  a && (v = new ResizeObserver((w) => {
    let [y] = w;
    y && y.target === u && v && (v.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var x;
      (x = v) == null || x.observe(t);
    })), n();
  }), u && !l && v.observe(u), v.observe(t));
  let b, m = l ? Le(e) : null;
  l && h();
  function h() {
    const w = Le(e);
    m && !Br(m, w) && n(), m = w, b = requestAnimationFrame(h);
  }
  return n(), () => {
    var w;
    d.forEach((y) => {
      r && y.removeEventListener("scroll", n), s && y.removeEventListener("resize", n);
    }), p == null || p(), (w = v) == null || w.disconnect(), v = null, l && cancelAnimationFrame(b);
  };
}
const Eu = Xl, Nu = ql, Mu = Kl, Pu = Ql, Au = jl, Po = Ul, Tu = Zl, Iu = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Cu,
    ...n
  }, s = {
    ...r.platform,
    _c: o
  };
  return Hl(e, t, {
    ...r,
    platform: s
  });
};
var _u = typeof document < "u", Ou = function() {
}, Pt = _u ? ji : Ou;
function Dt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Dt(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const s = r[o];
      if (!(s === "_owner" && e.$$typeof) && !Dt(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Wr(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ao(e, t) {
  const n = Wr(e);
  return Math.round(t * n) / n;
}
function pn(e) {
  const t = c.useRef(e);
  return Pt(() => {
    t.current = e;
  }), t;
}
function Du(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: s,
      floating: a
    } = {},
    transform: i = !0,
    whileElementsMounted: l,
    open: u
  } = e, [d, p] = c.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, v] = c.useState(o);
  Dt(g, o) || v(o);
  const [b, m] = c.useState(null), [h, w] = c.useState(null), y = c.useCallback((T) => {
    T !== N.current && (N.current = T, m(T));
  }, []), x = c.useCallback((T) => {
    T !== R.current && (R.current = T, w(T));
  }, []), C = s || b, S = a || h, N = c.useRef(null), R = c.useRef(null), A = c.useRef(d), k = l != null, D = pn(l), $ = pn(r), M = pn(u), B = c.useCallback(() => {
    if (!N.current || !R.current)
      return;
    const T = {
      placement: t,
      strategy: n,
      middleware: g
    };
    $.current && (T.platform = $.current), Iu(N.current, R.current, T).then((E) => {
      const G = {
        ...E,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: M.current !== !1
      };
      L.current && !Dt(A.current, G) && (A.current = G, Bt.flushSync(() => {
        p(G);
      }));
    });
  }, [g, t, n, $, M]);
  Pt(() => {
    u === !1 && A.current.isPositioned && (A.current.isPositioned = !1, p((T) => ({
      ...T,
      isPositioned: !1
    })));
  }, [u]);
  const L = c.useRef(!1);
  Pt(() => (L.current = !0, () => {
    L.current = !1;
  }), []), Pt(() => {
    if (C && (N.current = C), S && (R.current = S), C && S) {
      if (D.current)
        return D.current(C, S, B);
      B();
    }
  }, [C, S, B, D, k]);
  const z = c.useMemo(() => ({
    reference: N,
    floating: R,
    setReference: y,
    setFloating: x
  }), [y, x]), O = c.useMemo(() => ({
    reference: C,
    floating: S
  }), [C, S]), W = c.useMemo(() => {
    const T = {
      position: n,
      left: 0,
      top: 0
    };
    if (!O.floating)
      return T;
    const E = Ao(O.floating, d.x), G = Ao(O.floating, d.y);
    return i ? {
      ...T,
      transform: "translate(" + E + "px, " + G + "px)",
      ...Wr(O.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: E,
      top: G
    };
  }, [n, i, O.floating, d.x, d.y]);
  return c.useMemo(() => ({
    ...d,
    update: B,
    refs: z,
    elements: O,
    floatingStyles: W
  }), [d, B, z, O, W]);
}
const ku = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? Po({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? Po({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, Lu = (e, t) => ({
  ...Eu(e),
  options: [e, t]
}), Fu = (e, t) => ({
  ...Nu(e),
  options: [e, t]
}), $u = (e, t) => ({
  ...Tu(e),
  options: [e, t]
}), Bu = (e, t) => ({
  ...Mu(e),
  options: [e, t]
}), Wu = (e, t) => ({
  ...Pu(e),
  options: [e, t]
}), Vu = (e, t) => ({
  ...Au(e),
  options: [e, t]
}), zu = (e, t) => ({
  ...ku(e),
  options: [e, t]
});
var Gu = "Arrow", Vr = c.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...s } = e;
  return /* @__PURE__ */ f(
    V.svg,
    {
      ...s,
      ref: t,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ f("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Vr.displayName = Gu;
var Hu = Vr;
function Uu(e) {
  const [t, n] = c.useState(void 0);
  return J(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const s = r[0];
        let a, i;
        if ("borderBoxSize" in s) {
          const l = s.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          a = u.inlineSize, i = u.blockSize;
        } else
          a = e.offsetWidth, i = e.offsetHeight;
        n({ width: a, height: i });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Gn = "Popper", [zr, Zt] = Be(Gn), [Ku, Gr] = zr(Gn), Hr = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = c.useState(null);
  return /* @__PURE__ */ f(Ku, { scope: t, anchor: o, onAnchorChange: r, children: n });
};
Hr.displayName = Gn;
var Ur = "PopperAnchor", Kr = c.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...r } = e, s = Gr(Ur, n), a = c.useRef(null), i = X(t, a), l = c.useRef(null);
    return c.useEffect(() => {
      const u = l.current;
      l.current = (o == null ? void 0 : o.current) || a.current, u !== l.current && s.onAnchorChange(l.current);
    }), o ? null : /* @__PURE__ */ f(V.div, { ...r, ref: i });
  }
);
Kr.displayName = Ur;
var Hn = "PopperContent", [ju, Yu] = zr(Hn), jr = c.forwardRef(
  (e, t) => {
    var _, K, q, U, j, Y;
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: s = "center",
      alignOffset: a = 0,
      arrowPadding: i = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: p = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: v = "optimized",
      onPlaced: b,
      ...m
    } = e, h = Gr(Hn, n), [w, y] = c.useState(null), x = X(t, (oe) => y(oe)), [C, S] = c.useState(null), N = Uu(C), R = (N == null ? void 0 : N.width) ?? 0, A = (N == null ? void 0 : N.height) ?? 0, k = o + (s !== "center" ? "-" + s : ""), D = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, $ = Array.isArray(u) ? u : [u], M = $.length > 0, B = {
      padding: D,
      boundary: $.filter(qu),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: M
    }, { refs: L, floatingStyles: z, placement: O, isPositioned: W, middlewareData: T } = Du({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: k,
      whileElementsMounted: (...oe) => Ru(...oe, {
        animationFrame: v === "always"
      }),
      elements: {
        reference: h.anchor
      },
      middleware: [
        Lu({ mainAxis: r + A, alignmentAxis: a }),
        l && Fu({
          mainAxis: !0,
          crossAxis: !1,
          limiter: p === "partial" ? $u() : void 0,
          ...B
        }),
        l && Bu({ ...B }),
        Wu({
          ...B,
          apply: ({ elements: oe, rects: me, availableWidth: tt, availableHeight: nt }) => {
            const { width: ot, height: Ui } = me.reference, wt = oe.floating.style;
            wt.setProperty("--radix-popper-available-width", `${tt}px`), wt.setProperty("--radix-popper-available-height", `${nt}px`), wt.setProperty("--radix-popper-anchor-width", `${ot}px`), wt.setProperty("--radix-popper-anchor-height", `${Ui}px`);
          }
        }),
        C && zu({ element: C, padding: i }),
        Zu({ arrowWidth: R, arrowHeight: A }),
        g && Vu({ strategy: "referenceHidden", ...B })
      ]
    }), [E, G] = qr(O), H = ue(b);
    J(() => {
      W && (H == null || H());
    }, [W, H]);
    const te = (_ = T.arrow) == null ? void 0 : _.x, ye = (K = T.arrow) == null ? void 0 : K.y, ie = ((q = T.arrow) == null ? void 0 : q.centerOffset) !== 0, [xe, ne] = c.useState();
    return J(() => {
      w && ne(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ f(
      "div",
      {
        ref: L.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...z,
          transform: W ? z.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: xe,
          "--radix-popper-transform-origin": [
            (U = T.transformOrigin) == null ? void 0 : U.x,
            (j = T.transformOrigin) == null ? void 0 : j.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Y = T.hide) == null ? void 0 : Y.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ f(
          ju,
          {
            scope: n,
            placedSide: E,
            onArrowChange: S,
            arrowX: te,
            arrowY: ye,
            shouldHideArrow: ie,
            children: /* @__PURE__ */ f(
              V.div,
              {
                "data-side": E,
                "data-align": G,
                ...m,
                ref: x,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: W ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
jr.displayName = Hn;
var Yr = "PopperArrow", Xu = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Xr = c.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, s = Yu(Yr, o), a = Xu[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ f(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ f(
          Hu,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Xr.displayName = Yr;
function qu(e) {
  return e !== null;
}
var Zu = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var h, w, y;
    const { placement: n, rects: o, middlewareData: r } = t, a = ((h = r.arrow) == null ? void 0 : h.centerOffset) !== 0, i = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [u, d] = qr(n), p = { start: "0%", center: "50%", end: "100%" }[d], g = (((w = r.arrow) == null ? void 0 : w.x) ?? 0) + i / 2, v = (((y = r.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let b = "", m = "";
    return u === "bottom" ? (b = a ? p : `${g}px`, m = `${-l}px`) : u === "top" ? (b = a ? p : `${g}px`, m = `${o.floating.height + l}px`) : u === "right" ? (b = `${-l}px`, m = a ? p : `${v}px`) : u === "left" && (b = `${o.floating.width + l}px`, m = a ? p : `${v}px`), { data: { x: b, y: m } };
  }
});
function qr(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Un = Hr, Zr = Kr, Qr = jr, Jr = Xr, mn = "rovingFocusGroup.onEntryFocus", Qu = { bubbles: !1, cancelable: !0 }, gt = "RovingFocusGroup", [Cn, es, Ju] = kn(gt), [ed, ts] = Be(
  gt,
  [Ju]
), [td, nd] = ed(gt), ns = c.forwardRef(
  (e, t) => /* @__PURE__ */ f(Cn.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f(Cn.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f(od, { ...e, ref: t }) }) })
);
ns.displayName = gt;
var od = c.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: r = !1,
    dir: s,
    currentTabStopId: a,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: d = !1,
    ...p
  } = e, g = c.useRef(null), v = X(t, g), b = Ln(s), [m, h] = je({
    prop: a,
    defaultProp: i ?? null,
    onChange: l,
    caller: gt
  }), [w, y] = c.useState(!1), x = ue(u), C = es(n), S = c.useRef(!1), [N, R] = c.useState(0);
  return c.useEffect(() => {
    const A = g.current;
    if (A)
      return A.addEventListener(mn, x), () => A.removeEventListener(mn, x);
  }, [x]), /* @__PURE__ */ f(
    td,
    {
      scope: n,
      orientation: o,
      dir: b,
      loop: r,
      currentTabStopId: m,
      onItemFocus: c.useCallback(
        (A) => h(A),
        [h]
      ),
      onItemShiftTab: c.useCallback(() => y(!0), []),
      onFocusableItemAdd: c.useCallback(
        () => R((A) => A + 1),
        []
      ),
      onFocusableItemRemove: c.useCallback(
        () => R((A) => A - 1),
        []
      ),
      children: /* @__PURE__ */ f(
        V.div,
        {
          tabIndex: w || N === 0 ? -1 : 0,
          "data-orientation": o,
          ...p,
          ref: v,
          style: { outline: "none", ...e.style },
          onMouseDown: P(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: P(e.onFocus, (A) => {
            const k = !S.current;
            if (A.target === A.currentTarget && k && !w) {
              const D = new CustomEvent(mn, Qu);
              if (A.currentTarget.dispatchEvent(D), !D.defaultPrevented) {
                const $ = C().filter((O) => O.focusable), M = $.find((O) => O.active), B = $.find((O) => O.id === m), z = [M, B, ...$].filter(
                  Boolean
                ).map((O) => O.ref.current);
                ss(z, d);
              }
            }
            S.current = !1;
          }),
          onBlur: P(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), os = "RovingFocusGroupItem", rs = c.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: r = !1,
      tabStopId: s,
      children: a,
      ...i
    } = e, l = le(), u = s || l, d = nd(os, n), p = d.currentTabStopId === u, g = es(n), { onFocusableItemAdd: v, onFocusableItemRemove: b, currentTabStopId: m } = d;
    return c.useEffect(() => {
      if (o)
        return v(), () => b();
    }, [o, v, b]), /* @__PURE__ */ f(
      Cn.ItemSlot,
      {
        scope: n,
        id: u,
        focusable: o,
        active: r,
        children: /* @__PURE__ */ f(
          V.span,
          {
            tabIndex: p ? 0 : -1,
            "data-orientation": d.orientation,
            ...i,
            ref: t,
            onMouseDown: P(e.onMouseDown, (h) => {
              o ? d.onItemFocus(u) : h.preventDefault();
            }),
            onFocus: P(e.onFocus, () => d.onItemFocus(u)),
            onKeyDown: P(e.onKeyDown, (h) => {
              if (h.key === "Tab" && h.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (h.target !== h.currentTarget) return;
              const w = id(h, d.orientation, d.dir);
              if (w !== void 0) {
                if (h.metaKey || h.ctrlKey || h.altKey || h.shiftKey) return;
                h.preventDefault();
                let x = g().filter((C) => C.focusable).map((C) => C.ref.current);
                if (w === "last") x.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && x.reverse();
                  const C = x.indexOf(h.currentTarget);
                  x = d.loop ? ad(x, C + 1) : x.slice(C + 1);
                }
                setTimeout(() => ss(x));
              }
            }),
            children: typeof a == "function" ? a({ isCurrentTabStop: p, hasTabStop: m != null }) : a
          }
        )
      }
    );
  }
);
rs.displayName = os;
var rd = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function sd(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function id(e, t, n) {
  const o = sd(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return rd[o];
}
function ss(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function ad(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var cd = ns, ld = rs, Sn = ["Enter", " "], ud = ["ArrowDown", "PageUp", "Home"], is = ["ArrowUp", "PageDown", "End"], dd = [...ud, ...is], fd = {
  ltr: [...Sn, "ArrowRight"],
  rtl: [...Sn, "ArrowLeft"]
}, pd = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, ht = "Menu", [dt, md, gd] = kn(ht), [We, as] = Be(ht, [
  gd,
  Zt,
  ts
]), vt = Zt(), cs = ts(), [ls, Ie] = We(ht), [hd, bt] = We(ht), us = (e) => {
  const { __scopeMenu: t, open: n = !1, children: o, dir: r, onOpenChange: s, modal: a = !0 } = e, i = vt(t), [l, u] = c.useState(null), d = c.useRef(!1), p = ue(s), g = Ln(r);
  return c.useEffect(() => {
    const v = () => {
      d.current = !0, document.addEventListener("pointerdown", b, { capture: !0, once: !0 }), document.addEventListener("pointermove", b, { capture: !0, once: !0 });
    }, b = () => d.current = !1;
    return document.addEventListener("keydown", v, { capture: !0 }), () => {
      document.removeEventListener("keydown", v, { capture: !0 }), document.removeEventListener("pointerdown", b, { capture: !0 }), document.removeEventListener("pointermove", b, { capture: !0 });
    };
  }, []), /* @__PURE__ */ f(Un, { ...i, children: /* @__PURE__ */ f(
    ls,
    {
      scope: t,
      open: n,
      onOpenChange: p,
      content: l,
      onContentChange: u,
      children: /* @__PURE__ */ f(
        hd,
        {
          scope: t,
          onClose: c.useCallback(() => p(!1), [p]),
          isUsingKeyboardRef: d,
          dir: g,
          modal: a,
          children: o
        }
      )
    }
  ) });
};
us.displayName = ht;
var vd = "MenuAnchor", Kn = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = vt(n);
    return /* @__PURE__ */ f(Zr, { ...r, ...o, ref: t });
  }
);
Kn.displayName = vd;
var jn = "MenuPortal", [bd, ds] = We(jn, {
  forceMount: void 0
}), fs = (e) => {
  const { __scopeMenu: t, forceMount: n, children: o, container: r } = e, s = Ie(jn, t);
  return /* @__PURE__ */ f(bd, { scope: t, forceMount: n, children: /* @__PURE__ */ f(Te, { present: n || s.open, children: /* @__PURE__ */ f(Gt, { asChild: !0, container: r, children: o }) }) });
};
fs.displayName = jn;
var ae = "MenuContent", [wd, Yn] = We(ae), ps = c.forwardRef(
  (e, t) => {
    const n = ds(ae, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, s = Ie(ae, e.__scopeMenu), a = bt(ae, e.__scopeMenu);
    return /* @__PURE__ */ f(dt.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(Te, { present: o || s.open, children: /* @__PURE__ */ f(dt.Slot, { scope: e.__scopeMenu, children: a.modal ? /* @__PURE__ */ f(yd, { ...r, ref: t }) : /* @__PURE__ */ f(xd, { ...r, ref: t }) }) }) });
  }
), yd = c.forwardRef(
  (e, t) => {
    const n = Ie(ae, e.__scopeMenu), o = c.useRef(null), r = X(t, o);
    return c.useEffect(() => {
      const s = o.current;
      if (s) return In(s);
    }, []), /* @__PURE__ */ f(
      Xn,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: P(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), xd = c.forwardRef((e, t) => {
  const n = Ie(ae, e.__scopeMenu);
  return /* @__PURE__ */ f(
    Xn,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Cd = /* @__PURE__ */ Ye("MenuContent.ScrollLock"), Xn = c.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: o = !1,
      trapFocus: r,
      onOpenAutoFocus: s,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEntryFocus: l,
      onEscapeKeyDown: u,
      onPointerDownOutside: d,
      onFocusOutside: p,
      onInteractOutside: g,
      onDismiss: v,
      disableOutsideScroll: b,
      ...m
    } = e, h = Ie(ae, n), w = bt(ae, n), y = vt(n), x = cs(n), C = md(n), [S, N] = c.useState(null), R = c.useRef(null), A = X(t, R, h.onContentChange), k = c.useRef(0), D = c.useRef(""), $ = c.useRef(0), M = c.useRef(null), B = c.useRef("right"), L = c.useRef(0), z = b ? Ut : c.Fragment, O = b ? { as: Cd, allowPinchZoom: !0 } : void 0, W = (E) => {
      var _, K;
      const G = D.current + E, H = C().filter((q) => !q.disabled), te = document.activeElement, ye = (_ = H.find((q) => q.ref.current === te)) == null ? void 0 : _.textValue, ie = H.map((q) => q.textValue), xe = Dd(ie, G, ye), ne = (K = H.find((q) => q.textValue === xe)) == null ? void 0 : K.ref.current;
      (function q(U) {
        D.current = U, window.clearTimeout(k.current), U !== "" && (k.current = window.setTimeout(() => q(""), 1e3));
      })(G), ne && setTimeout(() => ne.focus());
    };
    c.useEffect(() => () => window.clearTimeout(k.current), []), Tn();
    const T = c.useCallback((E) => {
      var H, te;
      return B.current === ((H = M.current) == null ? void 0 : H.side) && Ld(E, (te = M.current) == null ? void 0 : te.area);
    }, []);
    return /* @__PURE__ */ f(
      wd,
      {
        scope: n,
        searchRef: D,
        onItemEnter: c.useCallback(
          (E) => {
            T(E) && E.preventDefault();
          },
          [T]
        ),
        onItemLeave: c.useCallback(
          (E) => {
            var G;
            T(E) || ((G = R.current) == null || G.focus(), N(null));
          },
          [T]
        ),
        onTriggerLeave: c.useCallback(
          (E) => {
            T(E) && E.preventDefault();
          },
          [T]
        ),
        pointerGraceTimerRef: $,
        onPointerGraceIntentChange: c.useCallback((E) => {
          M.current = E;
        }, []),
        children: /* @__PURE__ */ f(z, { ...O, children: /* @__PURE__ */ f(
          zt,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: P(s, (E) => {
              var G;
              E.preventDefault(), (G = R.current) == null || G.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ f(
              Vt,
              {
                asChild: !0,
                disableOutsidePointerEvents: i,
                onEscapeKeyDown: u,
                onPointerDownOutside: d,
                onFocusOutside: p,
                onInteractOutside: g,
                onDismiss: v,
                children: /* @__PURE__ */ f(
                  cd,
                  {
                    asChild: !0,
                    ...x,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: o,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: N,
                    onEntryFocus: P(l, (E) => {
                      w.isUsingKeyboardRef.current || E.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ f(
                      Qr,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Ts(h.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...y,
                        ...m,
                        ref: A,
                        style: { outline: "none", ...m.style },
                        onKeyDown: P(m.onKeyDown, (E) => {
                          const H = E.target.closest("[data-radix-menu-content]") === E.currentTarget, te = E.ctrlKey || E.altKey || E.metaKey, ye = E.key.length === 1;
                          H && (E.key === "Tab" && E.preventDefault(), !te && ye && W(E.key));
                          const ie = R.current;
                          if (E.target !== ie || !dd.includes(E.key)) return;
                          E.preventDefault();
                          const ne = C().filter((_) => !_.disabled).map((_) => _.ref.current);
                          is.includes(E.key) && ne.reverse(), _d(ne);
                        }),
                        onBlur: P(e.onBlur, (E) => {
                          E.currentTarget.contains(E.target) || (window.clearTimeout(k.current), D.current = "");
                        }),
                        onPointerMove: P(
                          e.onPointerMove,
                          ft((E) => {
                            const G = E.target, H = L.current !== E.clientX;
                            if (E.currentTarget.contains(G) && H) {
                              const te = E.clientX > L.current ? "right" : "left";
                              B.current = te, L.current = E.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
ps.displayName = ae;
var Sd = "MenuGroup", qn = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ f(V.div, { role: "group", ...o, ref: t });
  }
);
qn.displayName = Sd;
var Rd = "MenuLabel", ms = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ f(V.div, { ...o, ref: t });
  }
);
ms.displayName = Rd;
var kt = "MenuItem", To = "menu.itemSelect", Qt = c.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: o, ...r } = e, s = c.useRef(null), a = bt(kt, e.__scopeMenu), i = Yn(kt, e.__scopeMenu), l = X(t, s), u = c.useRef(!1), d = () => {
      const p = s.current;
      if (!n && p) {
        const g = new CustomEvent(To, { bubbles: !0, cancelable: !0 });
        p.addEventListener(To, (v) => o == null ? void 0 : o(v), { once: !0 }), jo(p, g), g.defaultPrevented ? u.current = !1 : a.onClose();
      }
    };
    return /* @__PURE__ */ f(
      gs,
      {
        ...r,
        ref: l,
        disabled: n,
        onClick: P(e.onClick, d),
        onPointerDown: (p) => {
          var g;
          (g = e.onPointerDown) == null || g.call(e, p), u.current = !0;
        },
        onPointerUp: P(e.onPointerUp, (p) => {
          var g;
          u.current || (g = p.currentTarget) == null || g.click();
        }),
        onKeyDown: P(e.onKeyDown, (p) => {
          const g = i.searchRef.current !== "";
          n || g && p.key === " " || Sn.includes(p.key) && (p.currentTarget.click(), p.preventDefault());
        })
      }
    );
  }
);
Qt.displayName = kt;
var gs = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: o = !1, textValue: r, ...s } = e, a = Yn(kt, n), i = cs(n), l = c.useRef(null), u = X(t, l), [d, p] = c.useState(!1), [g, v] = c.useState("");
    return c.useEffect(() => {
      const b = l.current;
      b && v((b.textContent ?? "").trim());
    }, [s.children]), /* @__PURE__ */ f(
      dt.ItemSlot,
      {
        scope: n,
        disabled: o,
        textValue: r ?? g,
        children: /* @__PURE__ */ f(ld, { asChild: !0, ...i, focusable: !o, children: /* @__PURE__ */ f(
          V.div,
          {
            role: "menuitem",
            "data-highlighted": d ? "" : void 0,
            "aria-disabled": o || void 0,
            "data-disabled": o ? "" : void 0,
            ...s,
            ref: u,
            onPointerMove: P(
              e.onPointerMove,
              ft((b) => {
                o ? a.onItemLeave(b) : (a.onItemEnter(b), b.defaultPrevented || b.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: P(
              e.onPointerLeave,
              ft((b) => a.onItemLeave(b))
            ),
            onFocus: P(e.onFocus, () => p(!0)),
            onBlur: P(e.onBlur, () => p(!1))
          }
        ) })
      }
    );
  }
), Ed = "MenuCheckboxItem", hs = c.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: o, ...r } = e;
    return /* @__PURE__ */ f(xs, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ f(
      Qt,
      {
        role: "menuitemcheckbox",
        "aria-checked": Lt(n) ? "mixed" : n,
        ...r,
        ref: t,
        "data-state": Jn(n),
        onSelect: P(
          r.onSelect,
          () => o == null ? void 0 : o(Lt(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
hs.displayName = Ed;
var vs = "MenuRadioGroup", [Nd, Md] = We(
  vs,
  { value: void 0, onValueChange: () => {
  } }
), bs = c.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: o, ...r } = e, s = ue(o);
    return /* @__PURE__ */ f(Nd, { scope: e.__scopeMenu, value: n, onValueChange: s, children: /* @__PURE__ */ f(qn, { ...r, ref: t }) });
  }
);
bs.displayName = vs;
var ws = "MenuRadioItem", ys = c.forwardRef(
  (e, t) => {
    const { value: n, ...o } = e, r = Md(ws, e.__scopeMenu), s = n === r.value;
    return /* @__PURE__ */ f(xs, { scope: e.__scopeMenu, checked: s, children: /* @__PURE__ */ f(
      Qt,
      {
        role: "menuitemradio",
        "aria-checked": s,
        ...o,
        ref: t,
        "data-state": Jn(s),
        onSelect: P(
          o.onSelect,
          () => {
            var a;
            return (a = r.onValueChange) == null ? void 0 : a.call(r, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
ys.displayName = ws;
var Zn = "MenuItemIndicator", [xs, Pd] = We(
  Zn,
  { checked: !1 }
), Cs = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: o, ...r } = e, s = Pd(Zn, n);
    return /* @__PURE__ */ f(
      Te,
      {
        present: o || Lt(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ f(
          V.span,
          {
            ...r,
            ref: t,
            "data-state": Jn(s.checked)
          }
        )
      }
    );
  }
);
Cs.displayName = Zn;
var Ad = "MenuSeparator", Ss = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ f(
      V.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...o,
        ref: t
      }
    );
  }
);
Ss.displayName = Ad;
var Td = "MenuArrow", Rs = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = vt(n);
    return /* @__PURE__ */ f(Jr, { ...r, ...o, ref: t });
  }
);
Rs.displayName = Td;
var Qn = "MenuSub", [Id, Es] = We(Qn), Ns = (e) => {
  const { __scopeMenu: t, children: n, open: o = !1, onOpenChange: r } = e, s = Ie(Qn, t), a = vt(t), [i, l] = c.useState(null), [u, d] = c.useState(null), p = ue(r);
  return c.useEffect(() => (s.open === !1 && p(!1), () => p(!1)), [s.open, p]), /* @__PURE__ */ f(Un, { ...a, children: /* @__PURE__ */ f(
    ls,
    {
      scope: t,
      open: o,
      onOpenChange: p,
      content: u,
      onContentChange: d,
      children: /* @__PURE__ */ f(
        Id,
        {
          scope: t,
          contentId: le(),
          triggerId: le(),
          trigger: i,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
Ns.displayName = Qn;
var it = "MenuSubTrigger", Ms = c.forwardRef(
  (e, t) => {
    const n = Ie(it, e.__scopeMenu), o = bt(it, e.__scopeMenu), r = Es(it, e.__scopeMenu), s = Yn(it, e.__scopeMenu), a = c.useRef(null), { pointerGraceTimerRef: i, onPointerGraceIntentChange: l } = s, u = { __scopeMenu: e.__scopeMenu }, d = c.useCallback(() => {
      a.current && window.clearTimeout(a.current), a.current = null;
    }, []);
    return c.useEffect(() => d, [d]), c.useEffect(() => {
      const p = i.current;
      return () => {
        window.clearTimeout(p), l(null);
      };
    }, [i, l]), /* @__PURE__ */ f(Kn, { asChild: !0, ...u, children: /* @__PURE__ */ f(
      gs,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": Ts(n.open),
        ...e,
        ref: pt(t, r.onTriggerChange),
        onClick: (p) => {
          var g;
          (g = e.onClick) == null || g.call(e, p), !(e.disabled || p.defaultPrevented) && (p.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: P(
          e.onPointerMove,
          ft((p) => {
            s.onItemEnter(p), !p.defaultPrevented && !e.disabled && !n.open && !a.current && (s.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
              n.onOpenChange(!0), d();
            }, 100));
          })
        ),
        onPointerLeave: P(
          e.onPointerLeave,
          ft((p) => {
            var v, b;
            d();
            const g = (v = n.content) == null ? void 0 : v.getBoundingClientRect();
            if (g) {
              const m = (b = n.content) == null ? void 0 : b.dataset.side, h = m === "right", w = h ? -5 : 5, y = g[h ? "left" : "right"], x = g[h ? "right" : "left"];
              s.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: p.clientX + w, y: p.clientY },
                  { x: y, y: g.top },
                  { x, y: g.top },
                  { x, y: g.bottom },
                  { x: y, y: g.bottom }
                ],
                side: m
              }), window.clearTimeout(i.current), i.current = window.setTimeout(
                () => s.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (s.onTriggerLeave(p), p.defaultPrevented) return;
              s.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: P(e.onKeyDown, (p) => {
          var v;
          const g = s.searchRef.current !== "";
          e.disabled || g && p.key === " " || fd[o.dir].includes(p.key) && (n.onOpenChange(!0), (v = n.content) == null || v.focus(), p.preventDefault());
        })
      }
    ) });
  }
);
Ms.displayName = it;
var Ps = "MenuSubContent", As = c.forwardRef(
  (e, t) => {
    const n = ds(ae, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, s = Ie(ae, e.__scopeMenu), a = bt(ae, e.__scopeMenu), i = Es(Ps, e.__scopeMenu), l = c.useRef(null), u = X(t, l);
    return /* @__PURE__ */ f(dt.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(Te, { present: o || s.open, children: /* @__PURE__ */ f(dt.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(
      Xn,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...r,
        ref: u,
        align: "start",
        side: a.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (d) => {
          var p;
          a.isUsingKeyboardRef.current && ((p = l.current) == null || p.focus()), d.preventDefault();
        },
        onCloseAutoFocus: (d) => d.preventDefault(),
        onFocusOutside: P(e.onFocusOutside, (d) => {
          d.target !== i.trigger && s.onOpenChange(!1);
        }),
        onEscapeKeyDown: P(e.onEscapeKeyDown, (d) => {
          a.onClose(), d.preventDefault();
        }),
        onKeyDown: P(e.onKeyDown, (d) => {
          var v;
          const p = d.currentTarget.contains(d.target), g = pd[a.dir].includes(d.key);
          p && g && (s.onOpenChange(!1), (v = i.trigger) == null || v.focus(), d.preventDefault());
        })
      }
    ) }) }) });
  }
);
As.displayName = Ps;
function Ts(e) {
  return e ? "open" : "closed";
}
function Lt(e) {
  return e === "indeterminate";
}
function Jn(e) {
  return Lt(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function _d(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function Od(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
function Dd(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, s = n ? e.indexOf(n) : -1;
  let a = Od(e, Math.max(s, 0));
  r.length === 1 && (a = a.filter((u) => u !== n));
  const l = a.find(
    (u) => u.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function kd(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let s = 0, a = t.length - 1; s < t.length; a = s++) {
    const i = t[s], l = t[a], u = i.x, d = i.y, p = l.x, g = l.y;
    d > o != g > o && n < (p - u) * (o - d) / (g - d) + u && (r = !r);
  }
  return r;
}
function Ld(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return kd(n, t);
}
function ft(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Fd = us, $d = Kn, Bd = fs, Wd = ps, Vd = qn, zd = ms, Gd = Qt, Hd = hs, Ud = bs, Kd = ys, jd = Cs, Yd = Ss, Xd = Rs, qd = Ns, Zd = Ms, Qd = As, Jt = "DropdownMenu", [Jd] = Be(
  Jt,
  [as]
), ee = as(), [ef, Is] = Jd(Jt), _s = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: o,
    open: r,
    defaultOpen: s,
    onOpenChange: a,
    modal: i = !0
  } = e, l = ee(t), u = c.useRef(null), [d, p] = je({
    prop: r,
    defaultProp: s ?? !1,
    onChange: a,
    caller: Jt
  });
  return /* @__PURE__ */ f(
    ef,
    {
      scope: t,
      triggerId: le(),
      triggerRef: u,
      contentId: le(),
      open: d,
      onOpenChange: p,
      onOpenToggle: c.useCallback(() => p((g) => !g), [p]),
      modal: i,
      children: /* @__PURE__ */ f(Fd, { ...l, open: d, onOpenChange: p, dir: o, modal: i, children: n })
    }
  );
};
_s.displayName = Jt;
var Os = "DropdownMenuTrigger", Ds = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: o = !1, ...r } = e, s = Is(Os, n), a = ee(n);
    return /* @__PURE__ */ f($d, { asChild: !0, ...a, children: /* @__PURE__ */ f(
      V.button,
      {
        type: "button",
        id: s.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": s.open ? "open" : "closed",
        "data-disabled": o ? "" : void 0,
        disabled: o,
        ...r,
        ref: pt(t, s.triggerRef),
        onPointerDown: P(e.onPointerDown, (i) => {
          !o && i.button === 0 && i.ctrlKey === !1 && (s.onOpenToggle(), s.open || i.preventDefault());
        }),
        onKeyDown: P(e.onKeyDown, (i) => {
          o || (["Enter", " "].includes(i.key) && s.onOpenToggle(), i.key === "ArrowDown" && s.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
        })
      }
    ) });
  }
);
Ds.displayName = Os;
var tf = "DropdownMenuPortal", ks = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, o = ee(t);
  return /* @__PURE__ */ f(Bd, { ...o, ...n });
};
ks.displayName = tf;
var Ls = "DropdownMenuContent", Fs = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Is(Ls, n), s = ee(n), a = c.useRef(!1);
    return /* @__PURE__ */ f(
      Wd,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...s,
        ...o,
        ref: t,
        onCloseAutoFocus: P(e.onCloseAutoFocus, (i) => {
          var l;
          a.current || (l = r.triggerRef.current) == null || l.focus(), a.current = !1, i.preventDefault();
        }),
        onInteractOutside: P(e.onInteractOutside, (i) => {
          const l = i.detail.originalEvent, u = l.button === 0 && l.ctrlKey === !0, d = l.button === 2 || u;
          (!r.modal || d) && (a.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Fs.displayName = Ls;
var nf = "DropdownMenuGroup", $s = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
    return /* @__PURE__ */ f(Vd, { ...r, ...o, ref: t });
  }
);
$s.displayName = nf;
var of = "DropdownMenuLabel", Bs = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
    return /* @__PURE__ */ f(zd, { ...r, ...o, ref: t });
  }
);
Bs.displayName = of;
var rf = "DropdownMenuItem", Ws = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
    return /* @__PURE__ */ f(Gd, { ...r, ...o, ref: t });
  }
);
Ws.displayName = rf;
var sf = "DropdownMenuCheckboxItem", Vs = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
  return /* @__PURE__ */ f(Hd, { ...r, ...o, ref: t });
});
Vs.displayName = sf;
var af = "DropdownMenuRadioGroup", zs = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
  return /* @__PURE__ */ f(Ud, { ...r, ...o, ref: t });
});
zs.displayName = af;
var cf = "DropdownMenuRadioItem", Gs = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
  return /* @__PURE__ */ f(Kd, { ...r, ...o, ref: t });
});
Gs.displayName = cf;
var lf = "DropdownMenuItemIndicator", Hs = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
  return /* @__PURE__ */ f(jd, { ...r, ...o, ref: t });
});
Hs.displayName = lf;
var uf = "DropdownMenuSeparator", Us = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
  return /* @__PURE__ */ f(Yd, { ...r, ...o, ref: t });
});
Us.displayName = uf;
var df = "DropdownMenuArrow", ff = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
    return /* @__PURE__ */ f(Xd, { ...r, ...o, ref: t });
  }
);
ff.displayName = df;
var pf = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: o, onOpenChange: r, defaultOpen: s } = e, a = ee(t), [i, l] = je({
    prop: o,
    defaultProp: s ?? !1,
    onChange: r,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ f(qd, { ...a, open: i, onOpenChange: l, children: n });
}, mf = "DropdownMenuSubTrigger", Ks = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
  return /* @__PURE__ */ f(Zd, { ...r, ...o, ref: t });
});
Ks.displayName = mf;
var gf = "DropdownMenuSubContent", js = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ee(n);
  return /* @__PURE__ */ f(
    Qd,
    {
      ...r,
      ...o,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
js.displayName = gf;
var hf = _s, vf = Ds, Ys = ks, Xs = Fs, bf = $s, qs = Bs, Zs = Ws, Qs = Vs, wf = zs, Js = Gs, ei = Hs, ti = Us, yf = pf, ni = Ks, oi = js;
const zp = hf, Gp = vf, Hp = bf, Up = Ys, Kp = yf, jp = wf, xf = c.forwardRef(({ className: e, inset: t, children: n, ...o }, r) => /* @__PURE__ */ Q(
  ni,
  {
    ref: r,
    className: I(
      "flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...o,
    children: [
      n,
      /* @__PURE__ */ f(Cl, { className: "ml-auto" })
    ]
  }
));
xf.displayName = ni.displayName;
const Cf = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  oi,
  {
    ref: n,
    className: I(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
Cf.displayName = oi.displayName;
const Sf = c.forwardRef(({ className: e, sideOffset: t = 4, ...n }, o) => /* @__PURE__ */ f(Ys, { children: /* @__PURE__ */ f(
  Xs,
  {
    ref: o,
    sideOffset: t,
    className: I(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
Sf.displayName = Xs.displayName;
const Rf = c.forwardRef(({ className: e, inset: t, ...n }, o) => /* @__PURE__ */ f(
  Zs,
  {
    ref: o,
    className: I(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...n
  }
));
Rf.displayName = Zs.displayName;
const Ef = c.forwardRef(({ className: e, children: t, checked: n, ...o }, r) => /* @__PURE__ */ Q(
  Qs,
  {
    ref: r,
    className: I(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...o,
    children: [
      /* @__PURE__ */ f("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f(ei, { children: /* @__PURE__ */ f(Mr, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
Ef.displayName = Qs.displayName;
const Nf = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ Q(
  Js,
  {
    ref: o,
    className: I(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ f("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f(ei, { children: /* @__PURE__ */ f(Rl, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
Nf.displayName = Js.displayName;
const Mf = c.forwardRef(({ className: e, inset: t, ...n }, o) => /* @__PURE__ */ f(
  qs,
  {
    ref: o,
    className: I(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
Mf.displayName = qs.displayName;
const Pf = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  ti,
  {
    ref: n,
    className: I("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
Pf.displayName = ti.displayName;
const Af = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "span",
  {
    className: I("ml-auto text-xs tracking-widest opacity-60", e),
    ...t
  }
);
Af.displayName = "DropdownMenuShortcut";
const Tf = c.forwardRef(
  ({ className: e, type: t, ...n }, o) => /* @__PURE__ */ f(
    "input",
    {
      type: t,
      className: I(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        e
      ),
      ref: o,
      ...n
    }
  )
);
Tf.displayName = "Input";
var If = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], _f = If.reduce((e, t) => {
  const n = /* @__PURE__ */ Vo(`Primitive.${t}`), o = c.forwardRef((r, s) => {
    const { asChild: a, ...i } = r, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(l, { ...i, ref: s });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {}), Of = "Label", ri = c.forwardRef((e, t) => /* @__PURE__ */ f(
  _f.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var r;
      n.target.closest("button, input, select, textarea") || ((r = e.onMouseDown) == null || r.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
ri.displayName = Of;
var si = ri;
const Df = Wt(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), kf = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  si,
  {
    ref: n,
    className: I(Df(), e),
    ...t
  }
));
kf.displayName = si.displayName;
function Io(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function Lf(e) {
  const t = c.useRef({ value: e, previous: e });
  return c.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var ii = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Ff = "VisuallyHidden", $f = c.forwardRef(
  (e, t) => /* @__PURE__ */ f(
    V.span,
    {
      ...e,
      ref: t,
      style: { ...ii, ...e.style }
    }
  )
);
$f.displayName = Ff;
var Bf = [" ", "Enter", "ArrowUp", "ArrowDown"], Wf = [" ", "Enter"], Fe = "Select", [en, tn, Vf] = kn(Fe), [et] = Be(Fe, [
  Vf,
  Zt
]), nn = Zt(), [zf, _e] = et(Fe), [Gf, Hf] = et(Fe), ai = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: s,
    value: a,
    defaultValue: i,
    onValueChange: l,
    dir: u,
    name: d,
    autoComplete: p,
    disabled: g,
    required: v,
    form: b
  } = e, m = nn(t), [h, w] = c.useState(null), [y, x] = c.useState(null), [C, S] = c.useState(!1), N = Ln(u), [R, A] = je({
    prop: o,
    defaultProp: r ?? !1,
    onChange: s,
    caller: Fe
  }), [k, D] = je({
    prop: a,
    defaultProp: i,
    onChange: l,
    caller: Fe
  }), $ = c.useRef(null), M = h ? b || !!h.closest("form") : !0, [B, L] = c.useState(/* @__PURE__ */ new Set()), z = Array.from(B).map((O) => O.props.value).join(";");
  return /* @__PURE__ */ f(Un, { ...m, children: /* @__PURE__ */ Q(
    zf,
    {
      required: v,
      scope: t,
      trigger: h,
      onTriggerChange: w,
      valueNode: y,
      onValueNodeChange: x,
      valueNodeHasChildren: C,
      onValueNodeHasChildrenChange: S,
      contentId: le(),
      value: k,
      onValueChange: D,
      open: R,
      onOpenChange: A,
      dir: N,
      triggerPointerDownPosRef: $,
      disabled: g,
      children: [
        /* @__PURE__ */ f(en.Provider, { scope: t, children: /* @__PURE__ */ f(
          Gf,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: c.useCallback((O) => {
              L((W) => new Set(W).add(O));
            }, []),
            onNativeOptionRemove: c.useCallback((O) => {
              L((W) => {
                const T = new Set(W);
                return T.delete(O), T;
              });
            }, []),
            children: n
          }
        ) }),
        M ? /* @__PURE__ */ Q(
          _i,
          {
            "aria-hidden": !0,
            required: v,
            tabIndex: -1,
            name: d,
            autoComplete: p,
            value: k,
            onChange: (O) => D(O.target.value),
            disabled: g,
            form: b,
            children: [
              k === void 0 ? /* @__PURE__ */ f("option", { value: "" }) : null,
              Array.from(B)
            ]
          },
          z
        ) : null
      ]
    }
  ) });
};
ai.displayName = Fe;
var ci = "SelectTrigger", li = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: o = !1, ...r } = e, s = nn(n), a = _e(ci, n), i = a.disabled || o, l = X(t, a.onTriggerChange), u = tn(n), d = c.useRef("touch"), [p, g, v] = Di((m) => {
      const h = u().filter((x) => !x.disabled), w = h.find((x) => x.value === a.value), y = ki(h, m, w);
      y !== void 0 && a.onValueChange(y.value);
    }), b = (m) => {
      i || (a.onOpenChange(!0), v()), m && (a.triggerPointerDownPosRef.current = {
        x: Math.round(m.pageX),
        y: Math.round(m.pageY)
      });
    };
    return /* @__PURE__ */ f(Zr, { asChild: !0, ...s, children: /* @__PURE__ */ f(
      V.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: i,
        "data-disabled": i ? "" : void 0,
        "data-placeholder": Oi(a.value) ? "" : void 0,
        ...r,
        ref: l,
        onClick: P(r.onClick, (m) => {
          m.currentTarget.focus(), d.current !== "mouse" && b(m);
        }),
        onPointerDown: P(r.onPointerDown, (m) => {
          d.current = m.pointerType;
          const h = m.target;
          h.hasPointerCapture(m.pointerId) && h.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (b(m), m.preventDefault());
        }),
        onKeyDown: P(r.onKeyDown, (m) => {
          const h = p.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && g(m.key), !(h && m.key === " ") && Bf.includes(m.key) && (b(), m.preventDefault());
        })
      }
    ) });
  }
);
li.displayName = ci;
var ui = "SelectValue", di = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, children: s, placeholder: a = "", ...i } = e, l = _e(ui, n), { onValueNodeHasChildrenChange: u } = l, d = s !== void 0, p = X(t, l.onValueNodeChange);
    return J(() => {
      u(d);
    }, [u, d]), /* @__PURE__ */ f(
      V.span,
      {
        ...i,
        ref: p,
        style: { pointerEvents: "none" },
        children: Oi(l.value) ? /* @__PURE__ */ f(ct, { children: a }) : s
      }
    );
  }
);
di.displayName = ui;
var Uf = "SelectIcon", fi = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: o, ...r } = e;
    return /* @__PURE__ */ f(V.span, { "aria-hidden": !0, ...r, ref: t, children: o || "▼" });
  }
);
fi.displayName = Uf;
var Kf = "SelectPortal", pi = (e) => /* @__PURE__ */ f(Gt, { asChild: !0, ...e });
pi.displayName = Kf;
var $e = "SelectContent", mi = c.forwardRef(
  (e, t) => {
    const n = _e($e, e.__scopeSelect), [o, r] = c.useState();
    if (J(() => {
      r(new DocumentFragment());
    }, []), !n.open) {
      const s = o;
      return s ? Bt.createPortal(
        /* @__PURE__ */ f(gi, { scope: e.__scopeSelect, children: /* @__PURE__ */ f(en.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ f("div", { children: e.children }) }) }),
        s
      ) : null;
    }
    return /* @__PURE__ */ f(hi, { ...e, ref: t });
  }
);
mi.displayName = $e;
var ce = 10, [gi, Oe] = et($e), jf = "SelectContentImpl", Yf = /* @__PURE__ */ Ye("SelectContent.RemoveScroll"), hi = c.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: o = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: s,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: i,
      sideOffset: l,
      align: u,
      alignOffset: d,
      arrowPadding: p,
      collisionBoundary: g,
      collisionPadding: v,
      sticky: b,
      hideWhenDetached: m,
      avoidCollisions: h,
      //
      ...w
    } = e, y = _e($e, n), [x, C] = c.useState(null), [S, N] = c.useState(null), R = X(t, (_) => C(_)), [A, k] = c.useState(null), [D, $] = c.useState(
      null
    ), M = tn(n), [B, L] = c.useState(!1), z = c.useRef(!1);
    c.useEffect(() => {
      if (x) return In(x);
    }, [x]), Tn();
    const O = c.useCallback(
      (_) => {
        const [K, ...q] = M().map((Y) => Y.ref.current), [U] = q.slice(-1), j = document.activeElement;
        for (const Y of _)
          if (Y === j || (Y == null || Y.scrollIntoView({ block: "nearest" }), Y === K && S && (S.scrollTop = 0), Y === U && S && (S.scrollTop = S.scrollHeight), Y == null || Y.focus(), document.activeElement !== j)) return;
      },
      [M, S]
    ), W = c.useCallback(
      () => O([A, x]),
      [O, A, x]
    );
    c.useEffect(() => {
      B && W();
    }, [B, W]);
    const { onOpenChange: T, triggerPointerDownPosRef: E } = y;
    c.useEffect(() => {
      if (x) {
        let _ = { x: 0, y: 0 };
        const K = (U) => {
          var j, Y;
          _ = {
            x: Math.abs(Math.round(U.pageX) - (((j = E.current) == null ? void 0 : j.x) ?? 0)),
            y: Math.abs(Math.round(U.pageY) - (((Y = E.current) == null ? void 0 : Y.y) ?? 0))
          };
        }, q = (U) => {
          _.x <= 10 && _.y <= 10 ? U.preventDefault() : x.contains(U.target) || T(!1), document.removeEventListener("pointermove", K), E.current = null;
        };
        return E.current !== null && (document.addEventListener("pointermove", K), document.addEventListener("pointerup", q, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", K), document.removeEventListener("pointerup", q, { capture: !0 });
        };
      }
    }, [x, T, E]), c.useEffect(() => {
      const _ = () => T(!1);
      return window.addEventListener("blur", _), window.addEventListener("resize", _), () => {
        window.removeEventListener("blur", _), window.removeEventListener("resize", _);
      };
    }, [T]);
    const [G, H] = Di((_) => {
      const K = M().filter((j) => !j.disabled), q = K.find((j) => j.ref.current === document.activeElement), U = ki(K, _, q);
      U && setTimeout(() => U.ref.current.focus());
    }), te = c.useCallback(
      (_, K, q) => {
        const U = !z.current && !q;
        (y.value !== void 0 && y.value === K || U) && (k(_), U && (z.current = !0));
      },
      [y.value]
    ), ye = c.useCallback(() => x == null ? void 0 : x.focus(), [x]), ie = c.useCallback(
      (_, K, q) => {
        const U = !z.current && !q;
        (y.value !== void 0 && y.value === K || U) && $(_);
      },
      [y.value]
    ), xe = o === "popper" ? Rn : vi, ne = xe === Rn ? {
      side: i,
      sideOffset: l,
      align: u,
      alignOffset: d,
      arrowPadding: p,
      collisionBoundary: g,
      collisionPadding: v,
      sticky: b,
      hideWhenDetached: m,
      avoidCollisions: h
    } : {};
    return /* @__PURE__ */ f(
      gi,
      {
        scope: n,
        content: x,
        viewport: S,
        onViewportChange: N,
        itemRefCallback: te,
        selectedItem: A,
        onItemLeave: ye,
        itemTextRefCallback: ie,
        focusSelectedItem: W,
        selectedItemText: D,
        position: o,
        isPositioned: B,
        searchRef: G,
        children: /* @__PURE__ */ f(Ut, { as: Yf, allowPinchZoom: !0, children: /* @__PURE__ */ f(
          zt,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (_) => {
              _.preventDefault();
            },
            onUnmountAutoFocus: P(r, (_) => {
              var K;
              (K = y.trigger) == null || K.focus({ preventScroll: !0 }), _.preventDefault();
            }),
            children: /* @__PURE__ */ f(
              Vt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: s,
                onPointerDownOutside: a,
                onFocusOutside: (_) => _.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ f(
                  xe,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (_) => _.preventDefault(),
                    ...w,
                    ...ne,
                    onPlaced: () => L(!0),
                    ref: R,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: P(w.onKeyDown, (_) => {
                      const K = _.ctrlKey || _.altKey || _.metaKey;
                      if (_.key === "Tab" && _.preventDefault(), !K && _.key.length === 1 && H(_.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(_.key)) {
                        let U = M().filter((j) => !j.disabled).map((j) => j.ref.current);
                        if (["ArrowUp", "End"].includes(_.key) && (U = U.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(_.key)) {
                          const j = _.target, Y = U.indexOf(j);
                          U = U.slice(Y + 1);
                        }
                        setTimeout(() => O(U)), _.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
hi.displayName = jf;
var Xf = "SelectItemAlignedPosition", vi = c.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...r } = e, s = _e($e, n), a = Oe($e, n), [i, l] = c.useState(null), [u, d] = c.useState(null), p = X(t, (R) => d(R)), g = tn(n), v = c.useRef(!1), b = c.useRef(!0), { viewport: m, selectedItem: h, selectedItemText: w, focusSelectedItem: y } = a, x = c.useCallback(() => {
    if (s.trigger && s.valueNode && i && u && m && h && w) {
      const R = s.trigger.getBoundingClientRect(), A = u.getBoundingClientRect(), k = s.valueNode.getBoundingClientRect(), D = w.getBoundingClientRect();
      if (s.dir !== "rtl") {
        const j = D.left - A.left, Y = k.left - j, oe = R.left - Y, me = R.width + oe, tt = Math.max(me, A.width), nt = window.innerWidth - ce, ot = Io(Y, [
          ce,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(ce, nt - tt)
        ]);
        i.style.minWidth = me + "px", i.style.left = ot + "px";
      } else {
        const j = A.right - D.right, Y = window.innerWidth - k.right - j, oe = window.innerWidth - R.right - Y, me = R.width + oe, tt = Math.max(me, A.width), nt = window.innerWidth - ce, ot = Io(Y, [
          ce,
          Math.max(ce, nt - tt)
        ]);
        i.style.minWidth = me + "px", i.style.right = ot + "px";
      }
      const $ = g(), M = window.innerHeight - ce * 2, B = m.scrollHeight, L = window.getComputedStyle(u), z = parseInt(L.borderTopWidth, 10), O = parseInt(L.paddingTop, 10), W = parseInt(L.borderBottomWidth, 10), T = parseInt(L.paddingBottom, 10), E = z + O + B + T + W, G = Math.min(h.offsetHeight * 5, E), H = window.getComputedStyle(m), te = parseInt(H.paddingTop, 10), ye = parseInt(H.paddingBottom, 10), ie = R.top + R.height / 2 - ce, xe = M - ie, ne = h.offsetHeight / 2, _ = h.offsetTop + ne, K = z + O + _, q = E - K;
      if (K <= ie) {
        const j = $.length > 0 && h === $[$.length - 1].ref.current;
        i.style.bottom = "0px";
        const Y = u.clientHeight - m.offsetTop - m.offsetHeight, oe = Math.max(
          xe,
          ne + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (j ? ye : 0) + Y + W
        ), me = K + oe;
        i.style.height = me + "px";
      } else {
        const j = $.length > 0 && h === $[0].ref.current;
        i.style.top = "0px";
        const oe = Math.max(
          ie,
          z + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (j ? te : 0) + ne
        ) + q;
        i.style.height = oe + "px", m.scrollTop = K - ie + m.offsetTop;
      }
      i.style.margin = `${ce}px 0`, i.style.minHeight = G + "px", i.style.maxHeight = M + "px", o == null || o(), requestAnimationFrame(() => v.current = !0);
    }
  }, [
    g,
    s.trigger,
    s.valueNode,
    i,
    u,
    m,
    h,
    w,
    s.dir,
    o
  ]);
  J(() => x(), [x]);
  const [C, S] = c.useState();
  J(() => {
    u && S(window.getComputedStyle(u).zIndex);
  }, [u]);
  const N = c.useCallback(
    (R) => {
      R && b.current === !0 && (x(), y == null || y(), b.current = !1);
    },
    [x, y]
  );
  return /* @__PURE__ */ f(
    Zf,
    {
      scope: n,
      contentWrapper: i,
      shouldExpandOnScrollRef: v,
      onScrollButtonChange: N,
      children: /* @__PURE__ */ f(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ f(
            V.div,
            {
              ...r,
              ref: p,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
vi.displayName = Xf;
var qf = "SelectPopperPosition", Rn = c.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: o = "start",
    collisionPadding: r = ce,
    ...s
  } = e, a = nn(n);
  return /* @__PURE__ */ f(
    Qr,
    {
      ...a,
      ...s,
      ref: t,
      align: o,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...s.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Rn.displayName = qf;
var [Zf, eo] = et($e, {}), En = "SelectViewport", bi = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: o, ...r } = e, s = Oe(En, n), a = eo(En, n), i = X(t, s.onViewportChange), l = c.useRef(0);
    return /* @__PURE__ */ Q(ct, { children: [
      /* @__PURE__ */ f(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ f(en.Slot, { scope: n, children: /* @__PURE__ */ f(
        V.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: i,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: P(r.onScroll, (u) => {
            const d = u.currentTarget, { contentWrapper: p, shouldExpandOnScrollRef: g } = a;
            if (g != null && g.current && p) {
              const v = Math.abs(l.current - d.scrollTop);
              if (v > 0) {
                const b = window.innerHeight - ce * 2, m = parseFloat(p.style.minHeight), h = parseFloat(p.style.height), w = Math.max(m, h);
                if (w < b) {
                  const y = w + v, x = Math.min(b, y), C = y - x;
                  p.style.height = x + "px", p.style.bottom === "0px" && (d.scrollTop = C > 0 ? C : 0, p.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }
);
bi.displayName = En;
var wi = "SelectGroup", [Qf, Jf] = et(wi), yi = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = le();
    return /* @__PURE__ */ f(Qf, { scope: n, id: r, children: /* @__PURE__ */ f(V.div, { role: "group", "aria-labelledby": r, ...o, ref: t }) });
  }
);
yi.displayName = wi;
var xi = "SelectLabel", Ci = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Jf(xi, n);
    return /* @__PURE__ */ f(V.div, { id: r.id, ...o, ref: t });
  }
);
Ci.displayName = xi;
var Ft = "SelectItem", [ep, Si] = et(Ft), Ri = c.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: o,
      disabled: r = !1,
      textValue: s,
      ...a
    } = e, i = _e(Ft, n), l = Oe(Ft, n), u = i.value === o, [d, p] = c.useState(s ?? ""), [g, v] = c.useState(!1), b = X(
      t,
      (y) => {
        var x;
        return (x = l.itemRefCallback) == null ? void 0 : x.call(l, y, o, r);
      }
    ), m = le(), h = c.useRef("touch"), w = () => {
      r || (i.onValueChange(o), i.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ f(
      ep,
      {
        scope: n,
        value: o,
        disabled: r,
        textId: m,
        isSelected: u,
        onItemTextChange: c.useCallback((y) => {
          p((x) => x || ((y == null ? void 0 : y.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ f(
          en.ItemSlot,
          {
            scope: n,
            value: o,
            disabled: r,
            textValue: d,
            children: /* @__PURE__ */ f(
              V.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": g ? "" : void 0,
                "aria-selected": u && g,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...a,
                ref: b,
                onFocus: P(a.onFocus, () => v(!0)),
                onBlur: P(a.onBlur, () => v(!1)),
                onClick: P(a.onClick, () => {
                  h.current !== "mouse" && w();
                }),
                onPointerUp: P(a.onPointerUp, () => {
                  h.current === "mouse" && w();
                }),
                onPointerDown: P(a.onPointerDown, (y) => {
                  h.current = y.pointerType;
                }),
                onPointerMove: P(a.onPointerMove, (y) => {
                  var x;
                  h.current = y.pointerType, r ? (x = l.onItemLeave) == null || x.call(l) : h.current === "mouse" && y.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: P(a.onPointerLeave, (y) => {
                  var x;
                  y.currentTarget === document.activeElement && ((x = l.onItemLeave) == null || x.call(l));
                }),
                onKeyDown: P(a.onKeyDown, (y) => {
                  var C;
                  ((C = l.searchRef) == null ? void 0 : C.current) !== "" && y.key === " " || (Wf.includes(y.key) && w(), y.key === " " && y.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Ri.displayName = Ft;
var at = "SelectItemText", Ei = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, ...s } = e, a = _e(at, n), i = Oe(at, n), l = Si(at, n), u = Hf(at, n), [d, p] = c.useState(null), g = X(
      t,
      (w) => p(w),
      l.onItemTextChange,
      (w) => {
        var y;
        return (y = i.itemTextRefCallback) == null ? void 0 : y.call(i, w, l.value, l.disabled);
      }
    ), v = d == null ? void 0 : d.textContent, b = c.useMemo(
      () => /* @__PURE__ */ f("option", { value: l.value, disabled: l.disabled, children: v }, l.value),
      [l.disabled, l.value, v]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: h } = u;
    return J(() => (m(b), () => h(b)), [m, h, b]), /* @__PURE__ */ Q(ct, { children: [
      /* @__PURE__ */ f(V.span, { id: l.textId, ...s, ref: g }),
      l.isSelected && a.valueNode && !a.valueNodeHasChildren ? Bt.createPortal(s.children, a.valueNode) : null
    ] });
  }
);
Ei.displayName = at;
var Ni = "SelectItemIndicator", Mi = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return Si(Ni, n).isSelected ? /* @__PURE__ */ f(V.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
Mi.displayName = Ni;
var Nn = "SelectScrollUpButton", Pi = c.forwardRef((e, t) => {
  const n = Oe(Nn, e.__scopeSelect), o = eo(Nn, e.__scopeSelect), [r, s] = c.useState(!1), a = X(t, o.onScrollButtonChange);
  return J(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const u = l.scrollTop > 0;
        s(u);
      };
      const l = n.viewport;
      return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ f(
    Ti,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: l } = n;
        i && l && (i.scrollTop = i.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Pi.displayName = Nn;
var Mn = "SelectScrollDownButton", Ai = c.forwardRef((e, t) => {
  const n = Oe(Mn, e.__scopeSelect), o = eo(Mn, e.__scopeSelect), [r, s] = c.useState(!1), a = X(t, o.onScrollButtonChange);
  return J(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const u = l.scrollHeight - l.clientHeight, d = Math.ceil(l.scrollTop) < u;
        s(d);
      };
      const l = n.viewport;
      return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ f(
    Ti,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: l } = n;
        i && l && (i.scrollTop = i.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Ai.displayName = Mn;
var Ti = c.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...r } = e, s = Oe("SelectScrollButton", n), a = c.useRef(null), i = tn(n), l = c.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return c.useEffect(() => () => l(), [l]), J(() => {
    var d;
    const u = i().find((p) => p.ref.current === document.activeElement);
    (d = u == null ? void 0 : u.ref.current) == null || d.scrollIntoView({ block: "nearest" });
  }, [i]), /* @__PURE__ */ f(
    V.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: P(r.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(o, 50));
      }),
      onPointerMove: P(r.onPointerMove, () => {
        var u;
        (u = s.onItemLeave) == null || u.call(s), a.current === null && (a.current = window.setInterval(o, 50));
      }),
      onPointerLeave: P(r.onPointerLeave, () => {
        l();
      })
    }
  );
}), tp = "SelectSeparator", Ii = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return /* @__PURE__ */ f(V.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
Ii.displayName = tp;
var Pn = "SelectArrow", np = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = nn(n), s = _e(Pn, n), a = Oe(Pn, n);
    return s.open && a.position === "popper" ? /* @__PURE__ */ f(Jr, { ...r, ...o, ref: t }) : null;
  }
);
np.displayName = Pn;
var op = "SelectBubbleInput", _i = c.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, o) => {
    const r = c.useRef(null), s = X(o, r), a = Lf(t);
    return c.useEffect(() => {
      const i = r.current;
      if (!i) return;
      const l = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (a !== t && d) {
        const p = new Event("change", { bubbles: !0 });
        d.call(i, t), i.dispatchEvent(p);
      }
    }, [a, t]), /* @__PURE__ */ f(
      V.select,
      {
        ...n,
        style: { ...ii, ...n.style },
        ref: s,
        defaultValue: t
      }
    );
  }
);
_i.displayName = op;
function Oi(e) {
  return e === "" || e === void 0;
}
function Di(e) {
  const t = ue(e), n = c.useRef(""), o = c.useRef(0), r = c.useCallback(
    (a) => {
      const i = n.current + a;
      t(i), (function l(u) {
        n.current = u, window.clearTimeout(o.current), u !== "" && (o.current = window.setTimeout(() => l(""), 1e3));
      })(i);
    },
    [t]
  ), s = c.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return c.useEffect(() => () => window.clearTimeout(o.current), []), [n, r, s];
}
function ki(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, s = n ? e.indexOf(n) : -1;
  let a = rp(e, Math.max(s, 0));
  r.length === 1 && (a = a.filter((u) => u !== n));
  const l = a.find(
    (u) => u.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function rp(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var sp = ai, Li = li, ip = di, ap = fi, cp = pi, Fi = mi, lp = bi, up = yi, $i = Ci, Bi = Ri, dp = Ei, fp = Mi, Wi = Pi, Vi = Ai, zi = Ii;
const Yp = sp, Xp = up, qp = ip, pp = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ Q(
  Li,
  {
    ref: o,
    className: I(
      "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ f(ap, { asChild: !0, children: /* @__PURE__ */ f(Pr, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
pp.displayName = Li.displayName;
const Gi = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Wi,
  {
    ref: n,
    className: I(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f(Sl, { className: "h-4 w-4" })
  }
));
Gi.displayName = Wi.displayName;
const Hi = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Vi,
  {
    ref: n,
    className: I(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f(Pr, { className: "h-4 w-4" })
  }
));
Hi.displayName = Vi.displayName;
const mp = c.forwardRef(({ className: e, children: t, position: n = "popper", ...o }, r) => /* @__PURE__ */ f(cp, { children: /* @__PURE__ */ Q(
  Fi,
  {
    ref: r,
    className: I(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...o,
    children: [
      /* @__PURE__ */ f(Gi, {}),
      /* @__PURE__ */ f(
        lp,
        {
          className: I(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ f(Hi, {})
    ]
  }
) }));
mp.displayName = Fi.displayName;
const gp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  $i,
  {
    ref: n,
    className: I("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
    ...t
  }
));
gp.displayName = $i.displayName;
const hp = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ Q(
  Bi,
  {
    ref: o,
    className: I(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ f("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f(fp, { children: /* @__PURE__ */ f(Mr, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ f(dp, { children: t })
    ]
  }
));
hp.displayName = Bi.displayName;
const vp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  zi,
  {
    ref: n,
    className: I("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
vp.displayName = zi.displayName;
const bp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ f(
  "table",
  {
    ref: n,
    className: I("w-full caption-bottom text-sm", e),
    ...t
  }
) }));
bp.displayName = "Table";
const wp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f("thead", { ref: n, className: I("[&_tr]:border-b", e), ...t }));
wp.displayName = "TableHeader";
const yp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "tbody",
  {
    ref: n,
    className: I("[&_tr:last-child]:border-0", e),
    ...t
  }
));
yp.displayName = "TableBody";
const xp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "tfoot",
  {
    ref: n,
    className: I(
      "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
      e
    ),
    ...t
  }
));
xp.displayName = "TableFooter";
const Cp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "tr",
  {
    ref: n,
    className: I(
      "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
      e
    ),
    ...t
  }
));
Cp.displayName = "TableRow";
const Sp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "th",
  {
    ref: n,
    className: I(
      "h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0",
      e
    ),
    ...t
  }
));
Sp.displayName = "TableHead";
const Rp = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "td",
  {
    ref: n,
    className: I("p-4 align-middle [&:has([role=checkbox])]:pr-0", e),
    ...t
  }
));
Rp.displayName = "TableCell";
const Ep = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "caption",
  {
    ref: n,
    className: I("mt-4 text-sm text-muted-foreground", e),
    ...t
  }
));
Ep.displayName = "TableCaption";
const Np = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "textarea",
  {
    className: I(
      "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      e
    ),
    ref: n,
    ...t
  }
));
Np.displayName = "Textarea";
const Mp = {
  sm: "max-w-screen-sm",
  md: "max-w-screen-md",
  lg: "max-w-screen-lg",
  xl: "max-w-screen-xl",
  full: "max-w-full"
}, $t = c.forwardRef(
  ({ className: e, size: t = "xl", ...n }, o) => /* @__PURE__ */ f(
    "div",
    {
      ref: o,
      className: I(
        "mx-auto w-full px-4 sm:px-6 lg:px-8",
        Mp[t],
        e
      ),
      ...n
    }
  )
);
$t.displayName = "Container";
const Pp = c.forwardRef(
  ({ className: e, logo: t, navigation: n, mobileNavigation: o, actions: r, sticky: s = !0, ...a }, i) => {
    const [l, u] = c.useState(!1);
    return /* @__PURE__ */ Q(
      "header",
      {
        ref: i,
        className: I(
          "w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60",
          s && "sticky top-0 z-50",
          e
        ),
        ...a,
        children: [
          /* @__PURE__ */ f($t, { children: /* @__PURE__ */ Q("div", { className: "flex h-16 items-center justify-between", children: [
            /* @__PURE__ */ Q("div", { className: "flex items-center gap-6", children: [
              t,
              /* @__PURE__ */ f("nav", { className: "hidden md:flex", children: n })
            ] }),
            /* @__PURE__ */ Q("div", { className: "flex items-center gap-4", children: [
              r,
              o && /* @__PURE__ */ f(
                "button",
                {
                  type: "button",
                  className: "inline-flex items-center justify-center rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-foreground md:hidden",
                  onClick: () => u(!l),
                  "aria-expanded": l,
                  "aria-label": "Toggle menu",
                  children: l ? /* @__PURE__ */ f("svg", { className: "h-6 w-6", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ f("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) }) : /* @__PURE__ */ f("svg", { className: "h-6 w-6", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ f("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 6h16M4 12h16M4 18h16" }) })
                }
              )
            ] })
          ] }) }),
          o && l && /* @__PURE__ */ f("div", { className: "border-t bg-background md:hidden", children: /* @__PURE__ */ f($t, { children: /* @__PURE__ */ f("nav", { className: "py-4", onClick: () => u(!1), children: o }) }) })
        ]
      }
    );
  }
);
Pp.displayName = "Header";
const Ap = c.forwardRef(
  ({
    className: e,
    logo: t,
    links: n,
    copyright: o = `© ${(/* @__PURE__ */ new Date()).getFullYear()} KMF Halal. All rights reserved.`,
    social: r,
    children: s,
    ...a
  }, i) => /* @__PURE__ */ f(
    "footer",
    {
      ref: i,
      className: I("border-t bg-muted/30", e),
      ...a,
      children: /* @__PURE__ */ f($t, { children: /* @__PURE__ */ f("div", { className: "py-10", children: s || /* @__PURE__ */ Q("div", { className: "flex flex-col gap-8 md:flex-row md:justify-between", children: [
        /* @__PURE__ */ Q("div", { className: "flex flex-col gap-4", children: [
          t,
          /* @__PURE__ */ f("p", { className: "text-sm text-muted-foreground", children: o })
        ] }),
        n && /* @__PURE__ */ f("div", { className: "flex gap-8", children: n }),
        r && /* @__PURE__ */ f("div", { className: "flex gap-4", children: r })
      ] }) }) })
    }
  )
);
Ap.displayName = "Footer";
const Tp = c.forwardRef(
  ({ className: e, items: t = [], renderLink: n, children: o, ...r }, s) => {
    const a = (i) => /* @__PURE__ */ f(
      "a",
      {
        href: i.href,
        className: I(
          "text-sm font-medium transition-colors hover:text-primary",
          i.active ? "text-foreground" : "text-muted-foreground"
        ),
        children: i.label
      },
      i.href
    );
    return /* @__PURE__ */ f("nav", { ref: s, className: I("flex items-center gap-6", e), ...r, children: o || t.map(
      (i) => n ? n(i) : a(i)
    ) });
  }
);
Tp.displayName = "Navigation";
const Ip = c.forwardRef(
  ({
    className: e,
    title: t,
    description: n,
    date: o,
    category: r,
    imageUrl: s,
    href: a,
    renderLink: i,
    ...l
  }, u) => {
    const d = /* @__PURE__ */ Q(
      Go,
      {
        ref: u,
        className: I(
          "overflow-hidden transition-shadow hover:shadow-lg",
          a && "cursor-pointer",
          e
        ),
        ...l,
        children: [
          s && /* @__PURE__ */ f("div", { className: "aspect-video w-full overflow-hidden", children: /* @__PURE__ */ f(
            "img",
            {
              src: s,
              alt: t,
              className: "h-full w-full object-cover transition-transform hover:scale-105"
            }
          ) }),
          /* @__PURE__ */ Q(Ho, { children: [
            /* @__PURE__ */ Q("div", { className: "flex items-center justify-between", children: [
              r && /* @__PURE__ */ f(_a, { variant: "secondary", children: r }),
              o && /* @__PURE__ */ f("span", { className: "text-xs text-muted-foreground", children: o })
            ] }),
            /* @__PURE__ */ f(Uo, { className: "line-clamp-2 text-lg", children: t })
          ] }),
          n && /* @__PURE__ */ f(Ko, { children: /* @__PURE__ */ f("p", { className: "line-clamp-3 text-sm text-muted-foreground", children: n }) })
        ]
      }
    );
    return a && i ? i({ children: d, href: a }) : a ? /* @__PURE__ */ f("a", { href: a, children: d }) : d;
  }
);
Ip.displayName = "ContentCard";
const _p = [
  { code: "ko", label: "한국어", href: "/" },
  { code: "en", label: "English", href: "/en" }
], Op = c.forwardRef(
  ({
    className: e,
    languages: t = _p,
    currentLanguage: n = "ko",
    onLanguageChange: o,
    renderLink: r,
    ...s
  }, a) => /* @__PURE__ */ f("div", { ref: a, className: I("flex gap-1", e), ...s, children: t.map((i) => {
    const l = i.code === n, u = /* @__PURE__ */ f(
      zo,
      {
        variant: l ? "default" : "ghost",
        size: "sm",
        onClick: () => o == null ? void 0 : o(i),
        children: i.label
      },
      i.code
    );
    return r && i.href ? r({ language: i, children: u }) : i.href && !l ? /* @__PURE__ */ f("a", { href: i.href, children: u }, i.code) : u;
  }) })
);
Op.displayName = "LanguageSwitcher";
const Dp = c.forwardRef(
  ({ className: e, html: t, ...n }, o) => /* @__PURE__ */ f(
    "div",
    {
      ref: o,
      className: I(
        "prose prose-slate max-w-none",
        // Headings
        "prose-headings:font-semibold prose-headings:text-foreground",
        "prose-h1:text-3xl prose-h2:text-2xl prose-h3:text-xl",
        // Paragraphs
        "prose-p:text-foreground prose-p:leading-7",
        // Links
        "prose-a:text-primary prose-a:underline-offset-4 hover:prose-a:text-primary/80",
        // Lists
        "prose-ul:list-disc prose-ol:list-decimal",
        "prose-li:text-foreground",
        // Images
        "prose-img:rounded-lg prose-img:shadow-md",
        // Blockquotes
        "prose-blockquote:border-l-primary prose-blockquote:text-muted-foreground",
        // Code
        "prose-code:rounded prose-code:bg-muted prose-code:px-1.5 prose-code:py-0.5",
        "prose-pre:bg-muted prose-pre:text-foreground",
        // Tables
        "prose-table:border prose-th:border prose-td:border",
        "prose-th:bg-muted prose-th:p-2 prose-td:p-2",
        e
      ),
      dangerouslySetInnerHTML: { __html: t },
      ...n
    }
  )
);
Dp.displayName = "RichContent";
export {
  Pa as Alert,
  Ta as AlertDescription,
  Aa as AlertTitle,
  _a as Badge,
  zo as Button,
  Go as Card,
  Ko as CardContent,
  za as CardDescription,
  Ga as CardFooter,
  Ho as CardHeader,
  Uo as CardTitle,
  $t as Container,
  Ip as ContentCard,
  Bp as Dialog,
  Vp as DialogClose,
  Ml as DialogContent,
  Il as DialogDescription,
  Al as DialogFooter,
  Pl as DialogHeader,
  Ar as DialogOverlay,
  Nl as DialogPortal,
  Tl as DialogTitle,
  Wp as DialogTrigger,
  zp as DropdownMenu,
  Ef as DropdownMenuCheckboxItem,
  Sf as DropdownMenuContent,
  Hp as DropdownMenuGroup,
  Rf as DropdownMenuItem,
  Mf as DropdownMenuLabel,
  Up as DropdownMenuPortal,
  jp as DropdownMenuRadioGroup,
  Nf as DropdownMenuRadioItem,
  Pf as DropdownMenuSeparator,
  Af as DropdownMenuShortcut,
  Kp as DropdownMenuSub,
  Cf as DropdownMenuSubContent,
  xf as DropdownMenuSubTrigger,
  Gp as DropdownMenuTrigger,
  Ap as Footer,
  Pp as Header,
  Tf as Input,
  kf as Label,
  Op as LanguageSwitcher,
  Tp as Navigation,
  Dp as RichContent,
  Yp as Select,
  mp as SelectContent,
  Xp as SelectGroup,
  hp as SelectItem,
  gp as SelectLabel,
  Hi as SelectScrollDownButton,
  Gi as SelectScrollUpButton,
  vp as SelectSeparator,
  pp as SelectTrigger,
  qp as SelectValue,
  bp as Table,
  yp as TableBody,
  Ep as TableCaption,
  Rp as TableCell,
  xp as TableFooter,
  Sp as TableHead,
  wp as TableHeader,
  Cp as TableRow,
  Np as Textarea,
  Ia as badgeVariants,
  Va as buttonVariants,
  I as cn
};
